(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9735],{

/***/ 93162:
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(a,b){if(true)!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_FACTORY__ = (b),
		__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
		(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));else {}})(this,function(){"use strict";function b(a,b){return"undefined"==typeof b?b={autoBom:!1}:"object"!=typeof b&&(console.warn("Deprecated: Expected third argument to be a object"),b={autoBom:!b}),b.autoBom&&/^\s*(?:text\/\S*|application\/xml|\S*\/\S*\+xml)\s*;.*charset\s*=\s*utf-8/i.test(a.type)?new Blob(["\uFEFF",a],{type:a.type}):a}function c(a,b,c){var d=new XMLHttpRequest;d.open("GET",a),d.responseType="blob",d.onload=function(){g(d.response,b,c)},d.onerror=function(){console.error("could not download file")},d.send()}function d(a){var b=new XMLHttpRequest;b.open("HEAD",a,!1);try{b.send()}catch(a){}return 200<=b.status&&299>=b.status}function e(a){try{a.dispatchEvent(new MouseEvent("click"))}catch(c){var b=document.createEvent("MouseEvents");b.initMouseEvent("click",!0,!0,window,0,0,0,80,20,!1,!1,!1,!1,0,null),a.dispatchEvent(b)}}var f="object"==typeof window&&window.window===window?window:"object"==typeof self&&self.self===self?self:"object"==typeof __webpack_require__.g&&__webpack_require__.g.global===__webpack_require__.g?__webpack_require__.g:void 0,a=f.navigator&&/Macintosh/.test(navigator.userAgent)&&/AppleWebKit/.test(navigator.userAgent)&&!/Safari/.test(navigator.userAgent),g=f.saveAs||("object"!=typeof window||window!==f?function(){}:"download"in HTMLAnchorElement.prototype&&!a?function(b,g,h){var i=f.URL||f.webkitURL,j=document.createElement("a");g=g||b.name||"download",j.download=g,j.rel="noopener","string"==typeof b?(j.href=b,j.origin===location.origin?e(j):d(j.href)?c(b,g,h):e(j,j.target="_blank")):(j.href=i.createObjectURL(b),setTimeout(function(){i.revokeObjectURL(j.href)},4E4),setTimeout(function(){e(j)},0))}:"msSaveOrOpenBlob"in navigator?function(f,g,h){if(g=g||f.name||"download","string"!=typeof f)navigator.msSaveOrOpenBlob(b(f,h),g);else if(d(f))c(f,g,h);else{var i=document.createElement("a");i.href=f,i.target="_blank",setTimeout(function(){e(i)})}}:function(b,d,e,g){if(g=g||open("","_blank"),g&&(g.document.title=g.document.body.innerText="downloading..."),"string"==typeof b)return c(b,d,e);var h="application/octet-stream"===b.type,i=/constructor/i.test(f.HTMLElement)||f.safari,j=/CriOS\/[\d]+/.test(navigator.userAgent);if((j||h&&i||a)&&"undefined"!=typeof FileReader){var k=new FileReader;k.onloadend=function(){var a=k.result;a=j?a:a.replace(/^data:[^;]*;/,"data:attachment/file;"),g?g.location.href=a:location=a,g=null},k.readAsDataURL(b)}else{var l=f.URL||f.webkitURL,m=l.createObjectURL(b);g?g.location=m:location.href=m,g=null,setTimeout(function(){l.revokeObjectURL(m)},4E4)}});f.saveAs=g.saveAs=g, true&&(module.exports=g)});

//# sourceMappingURL=FileSaver.min.js.map

/***/ }),

/***/ 60988:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "k": function() { return /* binding */ LeadCategory; }
/* harmony export */ });
var LeadCategory;
(function(LeadCategory) {
    LeadCategory["SweepsImage"] = "sweepsImage";
    LeadCategory["TourEntryLeadForm"] = "tourEntryLeadForm";
    LeadCategory["InTourLeadImage"] = "inTourLeadImage";
    LeadCategory["TourContactForm"] = "tourContactForm";
    LeadCategory["AssertTouchForm"] = "assertTouchForm";
})(LeadCategory || (LeadCategory = {}));


/***/ }),

/***/ 75293:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);

var SidebarHr = function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("hr", {
        style: {
            border: "1px solid #ffffff29",
            width: "80%",
            margin: "auto"
        }
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (SidebarHr);


/***/ }),

/***/ 96858:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Icon; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(69396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(62097);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(61225);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(61953);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);





function Icon(param) {
    var icon = param.icon, _style = param.style, style = _style === void 0 ? "far" : _style, _size = param.size, size = _size === void 0 ? "medium" : _size, onClick = param.onClick, sx = param.sx;
    var theme = (0,_mui_material__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)();
    var isMobile = (0,_mui_material__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(theme.breakpoints.down("sm"));
    // Logic for responsive icon font size. Will be finished later
    var fontSize = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function() {
        if (size === "large") {
            return isMobile ? "20px" : "30px";
        }
        if (size === "medium") {
            return isMobile ? "20px" : "20px";
        }
        return "15px";
    }, [
        size,
        isMobile
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
        onClick: onClick,
        component: "i",
        className: "".concat(style, " ").concat(icon, " fa-fw"),
        sx: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, sx), {
            fontSize: "".concat(fontSize, " !important"),
            color: theme.palette.common.white
        })
    });
}


/***/ }),

/***/ 48517:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "JO": function() { return /* reexport */ Icon/* default */.Z; },
  "Ee": function() { return /* reexport */ Image; },
  "lE": function() { return /* reexport */ MapResponsive; },
  "h2": function() { return /* reexport */ ResponsiveContainer; }
});

// UNUSED EXPORTS: SidebarHr

// EXTERNAL MODULE: ./components-new/common/icon/Icon.tsx
var Icon = __webpack_require__(96858);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Box/Box.js + 1 modules
var Box = __webpack_require__(61953);
// EXTERNAL MODULE: ./utils/getRatio.ts
var getRatio = __webpack_require__(19245);
;// CONCATENATED MODULE: ./components-new/common/MapResponsive.tsx



function MapResponsive(param) {
    var ratio = param.ratio, address = param.address;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
        component: "span",
        sx: {
            width: 1,
            lineHeight: 1,
            display: "block",
            overflow: "hidden",
            position: "relative",
            borderRadius: "5px",
            pt: (0,getRatio/* default */.Z)(ratio),
            "& .wrapper": {
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                lineHeight: 0,
                position: "absolute",
                backgroundSize: "cover !important"
            }
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
            className: "wrapper",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("iframe", {
                src: "https://www.google.com/maps/embed/v1/place?key=".concat("AIzaSyAxJYg1iR0WMy4vpFa3zB7E0Dx7lz8h5dk", "&q=").concat(address),
                style: {
                    width: "100%",
                    height: "100%"
                },
                loading: "lazy"
            })
        })
    });
}

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/react-lazy-load-image-component/build/index.js
var build = __webpack_require__(72679);
;// CONCATENATED MODULE: ./components-new/common/Image.tsx






function Image(_param) {
    var ratio = _param.ratio, _disabledEffect = _param.disabledEffect, disabledEffect = _disabledEffect === void 0 ? false : _disabledEffect, _effect = _param.effect, effect = _effect === void 0 ? "blur" : _effect, objectFit = _param.objectFit, overComponent = _param.overComponent, sx = _param.sx, other = (0,_object_without_properties/* default */.Z)(_param, [
        "ratio",
        "disabledEffect",
        "effect",
        "objectFit",
        "overComponent",
        "sx"
    ]);
    var imageComponent = /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, (0,_object_spread/* default */.Z)({
        component: build.LazyLoadImage,
        wrapperClassName: "wrapper",
        effect: disabledEffect ? undefined : effect,
        placeholderSrc: "https://treedis-public.s3-accelerate.amazonaws.com/assets/image-placeholder.svg",
        sx: {
            width: 1,
            height: 1,
            objectFit: objectFit
        }
    }, other));
    if (ratio) {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
            component: "span",
            sx: (0,_object_spread/* default */.Z)({
                width: 1,
                lineHeight: 1,
                display: "block",
                overflow: "hidden",
                position: "relative",
                pt: (0,getRatio/* default */.Z)(ratio),
                "& .wrapper": {
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    lineHeight: 0,
                    position: "absolute",
                    backgroundSize: "cover !important"
                }
            }, sx),
            children: [
                imageComponent,
                overComponent
            ]
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
        component: "span",
        sx: (0,_object_spread/* default */.Z)({
            lineHeight: 0,
            display: "block",
            overflow: "hidden",
            "& .wrapper": {
                width: 1,
                height: 1,
                backgroundSize: "cover !important"
            }
        }, sx),
        children: imageComponent
    });
}

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
;// CONCATENATED MODULE: ./components-new/common/ResponsiveContainer.tsx






function ResponsiveContainer(_param) {
    var _ratio = _param.ratio, ratio = _ratio === void 0 ? "1/1" : _ratio, containerStyles = _param.containerStyles, children = _param.children, other = (0,_object_without_properties/* default */.Z)(_param, [
        "ratio",
        "containerStyles",
        "children"
    ]);
    return ratio === "cover" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
        position: "relative",
        sx: {
            paddingTop: "100vh"
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
            sx: {
                position: "absolute",
                top: "43px",
                left: "-16px",
                width: "100vw",
                height: "calc(100vh - 59px)"
            },
            children: children
        })
    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
        component: "span",
        sx: (0,_object_spread/* default */.Z)({
            width: 1,
            lineHeight: 1,
            display: "block",
            overflow: "hidden",
            position: "relative",
            pt: (0,getRatio/* default */.Z)(ratio),
            "& .wrapper": {
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                lineHeight: 0,
                position: "absolute",
                backgroundSize: "cover !important"
            }
        }, containerStyles),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
            className: "wrapper",
            sx: {
                width: 1,
                height: 1
            }
        }, other), {
            children: children
        }))
    });
}

// EXTERNAL MODULE: ./components-new/common/SidebarHr.tsx
var SidebarHr = __webpack_require__(75293);
;// CONCATENATED MODULE: ./components-new/index.ts








/***/ }),

/***/ 79735:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ PublicAsset; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_assert_this_initialized.mjs
var _assert_this_initialized = __webpack_require__(4111);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(51438);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_inherits.mjs + 1 modules
var _inherits = __webpack_require__(88029);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_super.mjs + 1 modules
var _create_super = __webpack_require__(71418);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(20414);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-toastify/dist/react-toastify.esm.js
var react_toastify_esm = __webpack_require__(72132);
// EXTERNAL MODULE: ./components/common/LoadingProgress/index.tsx
var LoadingProgress = __webpack_require__(52641);
// EXTERNAL MODULE: ./_models/Tour.tsx + 1 modules
var Tour = __webpack_require__(40784);
// EXTERNAL MODULE: ./node_modules/react-modal/lib/index.js
var lib = __webpack_require__(83253);
var lib_default = /*#__PURE__*/__webpack_require__.n(lib);
// EXTERNAL MODULE: ./node_modules/react-slick/lib/index.js
var react_slick_lib = __webpack_require__(46066);
// EXTERNAL MODULE: ./_models/TourLead.ts
var TourLead = __webpack_require__(60988);
// EXTERNAL MODULE: ./units/Iframe/index.tsx + 1 modules
var Iframe = __webpack_require__(12978);
// EXTERNAL MODULE: ./components/common/CookieConsent.tsx
var CookieConsent = __webpack_require__(72789);
// EXTERNAL MODULE: ./components/util/all.ts
var util_all = __webpack_require__(40488);
// EXTERNAL MODULE: ./node_modules/downloadjs/download.js
var download = __webpack_require__(33729);
var download_default = /*#__PURE__*/__webpack_require__.n(download);
// EXTERNAL MODULE: ./node_modules/file-saver/dist/FileSaver.min.js
var FileSaver_min = __webpack_require__(93162);
// EXTERNAL MODULE: ./node_modules/jszip/dist/jszip.min.js
var jszip_min = __webpack_require__(55733);
var jszip_min_default = /*#__PURE__*/__webpack_require__.n(jszip_min);
// EXTERNAL MODULE: ./node_modules/uuid/dist/esm-browser/v4.js + 4 modules
var v4 = __webpack_require__(25934);
// EXTERNAL MODULE: ./node_modules/watermarkjs/dist/watermark.js
var watermark = __webpack_require__(60832);
var watermark_default = /*#__PURE__*/__webpack_require__.n(watermark);
// EXTERNAL MODULE: ./utils/file.ts
var file = __webpack_require__(94697);
// EXTERNAL MODULE: ./components/util/index.ts + 7 modules
var util = __webpack_require__(97666);
;// CONCATENATED MODULE: ./components/asset/helper.ts









var imageUrlToBlob = function(url) {
    return new Promise(function(resolve) {
        fetch(url, {
            headers: {}
        }).then(function(response) {
            resolve(response.blob());
        }).catch(function() {
            resolve(null);
        });
    });
};
// If width is a string, it will be treated as a percentage of the target width
var resizeWatermark = function(param) {
    var width = param.width, center = param.center, _opacity = param.opacity, opacity = _opacity === void 0 ? 1 : _opacity;
    return function(target, w) {
        var context = target.getContext("2d");
        context.save();
        var targetWidth = target.width;
        var targetHeight = target.height;
        // Convert percentage width to actual width
        var parsedWidth = typeof width === "string" ? parseFloat(width) / 100 * targetWidth : width;
        var widthRatio = w.width / parsedWidth;
        var height = w.height / widthRatio;
        // Set the opacity (global alpha) of the context
        context.globalAlpha = opacity;
        if (center) {
            context.drawImage(w, (targetWidth - parsedWidth) / 2, (targetHeight - height) / 2, parsedWidth, height);
        } else {
            context.drawImage(w, 10, 10, parsedWidth, height);
        }
        context.restore();
        return target;
    };
};
var prepareImageForDownload = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(param) {
        var url, tour, client, imageUrl, changed, logoUrl, ref, watermarkUrl;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    url = param.url, tour = param.tour;
                    client = tour.client;
                    imageUrl = "".concat(url).concat((0,util/* getVersion */.bo)(new Date()));
                    changed = false;
                    if (!!tour.unbranded) return [
                        3,
                        6
                    ];
                    if (!(client === null || client === void 0 ? void 0 : client.logo)) return [
                        3,
                        3
                    ];
                    logoUrl = "".concat("https://cdn.treedis.com", "/clients/").concat(client.id, "/logo.png").concat((0,util/* getVersion */.bo)(new Date()));
                    return [
                        4,
                        file/* default.existFile */.Z.existFile(logoUrl)
                    ];
                case 1:
                    if (!_state.sent()) return [
                        3,
                        3
                    ];
                    return [
                        4,
                        watermark_default()([
                            imageUrl,
                            logoUrl
                        ], {
                            init: function init(c) {
                                c.crossOrigin = "anonymous";
                            }
                        }).blob(resizeWatermark({
                            width: (client === null || client === void 0 ? void 0 : client.widthLogo) ? 250 : 150
                        }))
                    ];
                case 2:
                    imageUrl = _state.sent();
                    changed = true;
                    _state.label = 3;
                case 3:
                    if (!(client === null || client === void 0 ? void 0 : client.watermark)) return [
                        3,
                        6
                    ];
                    watermarkUrl = "".concat("https://cdn.treedis.com", "/clients/").concat((ref = tour.client) === null || ref === void 0 ? void 0 : ref.id, "/watermark.png").concat((0,util/* getVersion */.bo)(new Date()));
                    return [
                        4,
                        file/* default.existFile */.Z.existFile(watermarkUrl)
                    ];
                case 4:
                    if (!_state.sent()) return [
                        3,
                        6
                    ];
                    return [
                        4,
                        watermark_default()([
                            imageUrl,
                            watermarkUrl
                        ], {
                            init: function init(c) {
                                c.crossOrigin = "anonymous";
                            }
                        }).blob(resizeWatermark({
                            width: "30",
                            opacity: 0.5,
                            center: true
                        }))
                    ];
                case 5:
                    imageUrl = _state.sent();
                    changed = true;
                    _state.label = 6;
                case 6:
                    return [
                        2,
                        {
                            imageUrl: imageUrl,
                            changed: changed
                        }
                    ];
            }
        });
    });
    return function prepareImageForDownload(_) {
        return _ref.apply(this, arguments);
    };
}();
var downloadImage = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(url, tour) {
        var ref, imageUrl, changed, blob;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        prepareImageForDownload({
                            url: url,
                            tour: tour
                        })
                    ];
                case 1:
                    ref = _state.sent(), imageUrl = ref.imageUrl, changed = ref.changed;
                    return [
                        4,
                        imageUrlToBlob(imageUrl)
                    ];
                case 2:
                    blob = _state.sent();
                    download_default()(changed ? imageUrl : blob, "".concat((0,v4/* default */.Z)(), ".png"), "image/png");
                    return [
                        2
                    ];
            }
        });
    });
    return function downloadImage(url, tour) {
        return _ref.apply(this, arguments);
    };
}();
var downloadAllImages = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(images, tour) {
        var preparedImages, zip, galleryArchive;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        Promise.all(images.map(function(i) {
                            return prepareImageForDownload({
                                url: i,
                                tour: tour
                            });
                        }))
                    ];
                case 1:
                    preparedImages = _state.sent();
                    zip = new (jszip_min_default())();
                    galleryArchive = zip.folder("gallery");
                    return [
                        4,
                        Promise.all((preparedImages || []).map(function() {
                            var _ref = (0,_async_to_generator/* default */.Z)(function(param) {
                                var imageUrl, changed, imageBlob, _tmp;
                                return (0,tslib_es6.__generator)(this, function(_state) {
                                    switch(_state.label){
                                        case 0:
                                            imageUrl = param.imageUrl, changed = param.changed;
                                            if (!!changed) return [
                                                3,
                                                2
                                            ];
                                            return [
                                                4,
                                                imageUrlToBlob(imageUrl)
                                            ];
                                        case 1:
                                            _tmp = _state.sent();
                                            return [
                                                3,
                                                3
                                            ];
                                        case 2:
                                            _tmp = imageUrl;
                                            _state.label = 3;
                                        case 3:
                                            imageBlob = _tmp;
                                            if (imageBlob) {
                                                galleryArchive.file("".concat((0,v4/* default */.Z)(), ".jpg"), imageBlob, {
                                                    base64: true
                                                });
                                            }
                                            return [
                                                2
                                            ];
                                    }
                                });
                            });
                            return function(_) {
                                return _ref.apply(this, arguments);
                            };
                        }()))
                    ];
                case 2:
                    _state.sent();
                    return [
                        2,
                        zip.generateAsync({
                            type: "blob"
                        }).then(function(data) {
                            (0,FileSaver_min.saveAs)(data, "gallery.zip");
                            return true;
                        }).catch(function() {
                            return false;
                        })
                    ];
            }
        });
    });
    return function downloadAllImages(images, tour) {
        return _ref.apply(this, arguments);
    };
}();
/* harmony default export */ var helper = ({
    downloadAllImages: downloadAllImages
});

;// CONCATENATED MODULE: ./components/asset/overview/floorPlan/FloorPlan.tsx









var FloorPlan = /*#__PURE__*/ function(Component) {
    "use strict";
    (0,_inherits/* default */.Z)(FloorPlan, Component);
    var _super = (0,_create_super/* default */.Z)(FloorPlan);
    function FloorPlan(props) {
        (0,_class_call_check/* default */.Z)(this, FloorPlan);
        var _this;
        _this = _super.call(this, props);
        _this.switchPlan = props.switchPlan.bind((0,_assert_this_initialized/* default */.Z)(_this));
        return _this;
    }
    var _proto = FloorPlan.prototype;
    _proto.onPlanClick = function onPlanClick(url, index) {
        this.switchPlan(url, index);
    };
    _proto.downloadPdf = function downloadPdf(url) {
        var _this = this;
        return (0,_async_to_generator/* default */.Z)(function() {
            var _props, floorPlans, selectedPlan, plan;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _props = _this.props, floorPlans = _props.tour.floorPlans, selectedPlan = _props.selectedPlan;
                        plan = floorPlans.find(function(floorPlan) {
                            return floorPlan.url === selectedPlan;
                        });
                        return [
                            4,
                            (0,util_all/* downloadFloorPlan */.fg)(url, plan)
                        ];
                    case 1:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        })();
    };
    _proto.render = function render() {
        var _this = this;
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "section floorPlans w-100 h-100",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "plans",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "container",
                        style: {
                            display: "flex"
                        },
                        children: this.props.tour.floorPlans.map(function(plan, i) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                style: plan.name && plan.name.length > 0 ? {
                                    display: "inline-block"
                                } : {
                                    display: "none"
                                },
                                className: plan.selected ? "selected" : "",
                                onClick: _this.onPlanClick.bind(_this, plan.url, i),
                                children: plan.name
                            }, i);
                        })
                    })
                }),
                this.props.selectedPlan && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: this.props.imgLong ? "plan w-100 h-75" : "plan w-100 h-67",
                    style: {
                        backgroundImage: "url(".concat("https://cdn.treedis.com", "/tours/").concat(this.props.tour.id, "/floorplans/").concat(this.props.selectedPlan.split(".")[0], ".webp)")
                    }
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "d-flex justify-content-center",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                            className: "square-button",
                            onClick: function() {
                                return _this.downloadPdf("".concat("https://cdn.treedis.com", "/tours/").concat(_this.props.tour.id, "/floorplans/").concat(_this.props.selectedPlan));
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                    className: "fas fa-file-pdf"
                                }),
                                this.props.tour.client && this.props.tour.client.rtl ? "הורד PDF" : "Download PDF"
                            ]
                        })
                    })
                })
            ]
        });
    };
    return FloorPlan;
}(react.Component);


;// CONCATENATED MODULE: ./components/asset/overview/map/Map.tsx


var Map = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Iframe/* default */.Z, {
        logoSrc: props.logo,
        frameBorder: "0",
        className: "h-100 w-100",
        src: "https://www.google.com/maps/embed/v1/place?key=".concat(props.googleKey, "&q=").concat(props.address),
        allowFullscreen: true
    });
};
/* harmony default export */ var map_Map = (Map);

;// CONCATENATED MODULE: ./components/asset/overview/summary/Summary.tsx

var Summary = function(param) {
    var tour = param.tour;
    /*#__PURE__*/ return (0,jsx_runtime.jsxs)("div", {
        className: "summary-block",
        children: [
            (tour === null || tour === void 0 ? void 0 : tour.summary) && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: "m-0 mw-100 p-3",
                dangerouslySetInnerHTML: {
                    __html: tour === null || tour === void 0 ? void 0 : tour.summary
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "clearfix"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "line"
            }),
            tour.amenities && /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                children: tour.client.rtl ? "מאפיינים" : "AMENITIES"
            })
        ]
    });
};
/* harmony default export */ var summary_Summary = (Summary);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 3 modules
var styled_components_browser_esm = __webpack_require__(18533);
;// CONCATENATED MODULE: ./components/asset/style.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  bottom: 10px;\n  left: 10px;\n  font-size: 1em;\n  cursor: pointer;\n  color: #fff;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var DownloadAll = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    displayName: "style__DownloadAll",
    componentId: "sc-37007014-0"
})(_templateObject());

;// CONCATENATED MODULE: ./components/asset/classic/ClassicPublicAsset.tsx
/* eslint-disable class-methods-use-this,react/jsx-no-bind */ 






















var ClassicPublicAsset = /*#__PURE__*/ function(Component) {
    "use strict";
    (0,_inherits/* default */.Z)(ClassicPublicAsset, Component);
    var _super = (0,_create_super/* default */.Z)(ClassicPublicAsset);
    function ClassicPublicAsset(props) {
        (0,_class_call_check/* default */.Z)(this, ClassicPublicAsset);
        var _this;
        _this = _super.call(this, props);
        _this.state = {
            tour: null,
            play: false,
            menuOpen: false,
            videoOpen: false,
            galleryOpen: false,
            menuOpened: false,
            selectedPlan: null,
            readMore: false,
            images: [],
            newLead: {
                name: null,
                email: null,
                phone: null,
                message: null
            },
            downloading: false,
            imageLoading: false
        };
        _this.toggleGallery = _this.toggleGallery.bind((0,_assert_this_initialized/* default */.Z)(_this));
        return _this;
    }
    var _proto = ClassicPublicAsset.prototype;
    _proto.componentDidMount = function componentDidMount() {
        var tour = this.props.tour;
        this.setState({
            tour: tour,
            selectedPlan: tour.floorPlans.length > 0 ? tour.floorPlans[0].url : null
        });
        var clicked = this.props.menuItemClickedBookingPage;
        if (clicked) {
            if (clicked === "gallery") {
                this.toggleGallery();
            } else {
                setTimeout(this.scrollTo.bind(this, clicked), 1000);
            }
        }
    };
    _proto.toggleMenu = function toggleMenu() {
        this.setState({
            menuOpened: true,
            menuOpen: !this.state.menuOpen
        });
    };
    _proto.toggleVideo = function toggleVideo() {
        this.setState({
            videoOpen: !this.state.videoOpen,
            menuOpen: false,
            galleryOpen: false
        });
    };
    _proto.toggleGallery = function toggleGallery() {
        var tour = this.state.tour ? this.state.tour : this.props.tour;
        if (this.state.images.length === 0) {
            var _this = this;
            util_all/* fetchData */.rQ("public/getAllTourImages", "POST", {
                id: tour.id
            }).then(function() {
                var _ref = (0,_async_to_generator/* default */.Z)(function(data) {
                    var images;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        if (!data.images) {
                            react_toastify_esm/* toast.error */.Am.error("Couldn't load images");
                        } else {
                            images = data.images.map(function(img) {
                                return "".concat(_this.props.reactAws, "/tours/").concat(tour.id, "/images/").concat(img.url);
                            });
                            _this.setState({
                                images: images
                            });
                        }
                        return [
                            2
                        ];
                    });
                });
                return function(data) {
                    return _ref.apply(this, arguments);
                };
            }()).catch(function(err) {
                console.error(err.message);
            });
        }
        this.setState({
            galleryOpen: !this.state.galleryOpen,
            menuOpen: false,
            videoOpen: false
        });
    };
    _proto.scrollTo = function scrollTo(to) {
        to.scrollIntoView({
            behavior: "smooth",
            block: "start"
        });
        this.setState({
            menuOpen: false
        });
    };
    _proto.editLead = function editLead(event) {
        var name = event.target.name;
        var value = event.target.type === "checkbox" ? event.target.checked : event.target.value;
        var newLead = this.state.newLead;
        newLead[name] = value;
        this.setState({
            newLead: newLead
        });
    };
    _proto.sendLead = function sendLead() {
        var _this = this;
        return (0,_async_to_generator/* default */.Z)(function() {
            var ref, ref1, params, _tour, tourEmail, client, id, err;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        params = Object.assign(_this.state.newLead, {
                            tour: _this.state.tour.title,
                            userId: _this.state.tour.userId,
                            link: window.location.href,
                            clientId: (ref = _this.state.tour) === null || ref === void 0 ? void 0 : (ref1 = ref.client) === null || ref1 === void 0 ? void 0 : ref1.id
                        });
                        _tour = _this.state.tour, tourEmail = _tour.tourEmail, client = _tour.client, id = _tour.id;
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            4,
                            ,
                            5
                        ]);
                        return [
                            4,
                            (0,util_all/* fetchData */.rQ)("public/sendEmail", "POST", {
                                to: tourEmail && tourEmail.assertGetInTouch || client && client.email,
                                params: params
                            })
                        ];
                    case 2:
                        _state.sent();
                        react_toastify_esm/* toast.success */.Am.success("E-Mail sent");
                        _this.setState({
                            newLead: {
                                name: null,
                                email: null,
                                phone: null,
                                message: null
                            }
                        });
                        return [
                            4,
                            (0,util_all/* fetchData */.rQ)("public/setTourLead", "POST", {
                                name: params.name,
                                email: params.email,
                                phone: params.phone,
                                category: TourLead/* LeadCategory.AssertTouchForm */.k.AssertTouchForm,
                                tourId: id
                            })
                        ];
                    case 3:
                        _state.sent();
                        return [
                            3,
                            5
                        ];
                    case 4:
                        err = _state.sent();
                        console.error(err.message);
                        return [
                            3,
                            5
                        ];
                    case 5:
                        return [
                            2
                        ];
                }
            });
        })();
    };
    _proto.switchPlan = function switchPlan(url, index) {
        var tour = this.state.tour;
        tour.floorPlans.map(function(plan) {
            plan.selected = false;
            return plan;
        });
        tour.floorPlans[index].selected = true;
        this.setState({
            tour: tour,
            selectedPlan: url
        });
    };
    _proto.downloadCurrentImage = function downloadCurrentImage(url) {
        var _this = this;
        return (0,_async_to_generator/* default */.Z)(function() {
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _this.setState({
                            imageLoading: true
                        });
                        return [
                            4,
                            downloadImage(url, _this.state.tour)
                        ];
                    case 1:
                        _state.sent();
                        _this.setState({
                            imageLoading: false
                        });
                        return [
                            2
                        ];
                }
            });
        })();
    };
    _proto.downloadAll = function downloadAll() {
        var _this = this;
        return (0,_async_to_generator/* default */.Z)(function() {
            var images;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        images = _this.state.images;
                        _this.setState({
                            downloading: true
                        });
                        return [
                            4,
                            downloadAllImages(images, _this.state.tour)
                        ];
                    case 1:
                        _state.sent();
                        _this.setState({
                            downloading: false
                        });
                        return [
                            2
                        ];
                }
            });
        })();
    };
    _proto.render = function render() {
        var _this = this;
        var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14, ref15, ref16, ref17, ref18, ref19, ref20, ref21, ref22, ref23, ref24, ref25, ref26, ref27, ref28, ref29, ref30, ref31, ref32, ref33, ref34, ref35, ref36, ref37, ref38;
        var _state = this.state, tour = _state.tour, downloading = _state.downloading, imageLoading = _state.imageLoading;
        var logo;
        var iframeSrcPrefixByTourType;
        var summaryOn = false;
        var floorPlansOn = false;
        var whitelabel = this.props.whitelabel;
        var fbAppId = (tour === null || tour === void 0 ? void 0 : (ref = tour.client) === null || ref === void 0 ? void 0 : ref.fbAppId) || (tour === null || tour === void 0 ? void 0 : (ref1 = tour.user) === null || ref1 === void 0 ? void 0 : ref1.fbAppId);
        if (tour) {
            var ref39;
            summaryOn = (tour === null || tour === void 0 ? void 0 : (ref39 = tour.summary) === null || ref39 === void 0 ? void 0 : ref39.length) > 0;
            floorPlansOn = tour.floorPlansEnabled && !!tour.floorPlans.length;
            logo = tour.client && !tour.unbranded && tour.client.logo ? "".concat(this.props.reactAws, "/clients/").concat(tour.client.id, "/logo.png").concat(util_all/* getVersion */.bo(tour.client.updatedAt)) : null;
            iframeSrcPrefixByTourType = Tour/* TourTypeURL */.YO[tour.mode];
        }
        if (this.state.loading || !tour) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(LoadingProgress/* default */.Z, {});
        }
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            id: "public-asset-root",
            ref: function(el) {
                _this.root = el;
            },
            className: ((ref2 = tour.client) === null || ref2 === void 0 ? void 0 : ref2.rtl) ? "rtl" : "ltr",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)((lib_default()), {
                    className: "popup",
                    isOpen: this.state.videoOpen,
                    onRequestClose: this.toggleVideo.bind(this),
                    appElement: this.root,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                            onClick: this.toggleVideo.bind(this),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                className: "fa fa-times"
                            })
                        }),
                        tour.videoUrl && /*#__PURE__*/ (0,jsx_runtime.jsx)(Iframe/* default */.Z, {
                            logoSrc: whitelabel === null || whitelabel === void 0 ? void 0 : whitelabel.logo,
                            src: util_all/* getVideoLink */.rp(tour.videoUrl),
                            allowFullscreen: true
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)((lib_default()), {
                    className: "popup",
                    isOpen: this.state.galleryOpen,
                    onRequestClose: this.toggleGallery.bind(this),
                    appElement: this.root,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                            onClick: this.toggleGallery.bind(this),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                className: "fa fa-times"
                            })
                        }),
                        tour.client && tour.client.logo && /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            alt: "",
                            className: tour.client.widthLogo ? "logo width" : "logo",
                            src: "".concat(this.props.reactAws, "/clients/").concat(tour.client.id, "/logo.png").concat(util_all/* getVersion */.bo(tour.client.updatedAt))
                        }),
                        tour.client && tour.client.watermark && /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            alt: "",
                            className: "watermark",
                            src: "".concat(this.props.reactAws, "/clients/").concat(tour.client.id, "/watermark.png").concat(util_all/* getVersion */.bo(tour.client.updatedAt))
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(react_slick_lib/* default */.Z, {
                            className: "gallery-slider",
                            infinite: false,
                            arrows: true,
                            autoplay: false,
                            dots: false,
                            fade: false,
                            children: this.state.images.map(function(image, i) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "bg",
                                        style: {
                                            backgroundImage: "url(".concat(image, ")")
                                        },
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(DownloadAll, {
                                                onClick: _this.downloadAll.bind(_this),
                                                children: downloading ? /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                    className: "fas fa-spinner fa-spin"
                                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                    className: "fas fa-angle-double-down"
                                                })
                                            }),
                                            imageLoading ? /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                className: "download fas fa-spinner fa-spin"
                                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                onClick: _this.downloadCurrentImage.bind(_this, image),
                                                className: "download fas fa-cloud-download-alt"
                                            })
                                        ]
                                    })
                                }, i);
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: this.state.menuOpen ? "buttonBg open" : this.state.menuOpened ? "buttonBg" : "buttonBg animation",
                    onClick: this.toggleMenu.bind(this),
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                            className: this.state.menuOpen ? "hamburger hamburger--spin is-active" : "hamburger hamburger--spin",
                            type: "button",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "hamburger-box",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "hamburger-inner"
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            children: (ref3 = tour.translation) === null || ref3 === void 0 ? void 0 : ref3.menu
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("nav", {
                    className: this.state.menuOpen ? "open" : "",
                    children: [
                        tour.address && /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                            onClick: this.scrollTo.bind(this, this.map),
                            children: (ref4 = tour.translation) === null || ref4 === void 0 ? void 0 : ref4.map
                        }),
                        tour.videoUrl && /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                            onClick: this.toggleVideo.bind(this),
                            children: (ref5 = tour.translation) === null || ref5 === void 0 ? void 0 : ref5.playVideo
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                            onClick: this.toggleGallery.bind(this),
                            children: (ref6 = tour.translation) === null || ref6 === void 0 ? void 0 : ref6.gallery
                        }),
                        floorPlansOn && /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                            onClick: this.scrollTo.bind(this, this.floorPlans),
                            children: (ref7 = tour.translation) === null || ref7 === void 0 ? void 0 : ref7.floorPlans
                        }),
                        tour.amenities && /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                            onClick: this.scrollTo.bind(this, this.amenities),
                            children: (ref8 = tour.translation) === null || ref8 === void 0 ? void 0 : ref8.amenities
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                            onClick: this.scrollTo.bind(this, this.matterTour),
                            children: (ref9 = tour.translation) === null || ref9 === void 0 ? void 0 : ref9.threeDTour
                        }),
                        !tour.unbranded && /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                            onClick: this.scrollTo.bind(this, this.contact),
                            children: (ref10 = tour.translation) === null || ref10 === void 0 ? void 0 : ref10.contact
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: this.state.menuOpen ? "content open" : "content",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "intro",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "container",
                                    children: [
                                        logo && /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                            alt: "",
                                            className: ((ref11 = tour.client) === null || ref11 === void 0 ? void 0 : ref11.widthLogo) ? "logo width" : "logo",
                                            src: logo
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "info-container",
                                            style: {
                                                bottom: !tour.address ? "70px" : " 130px"
                                            },
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "title-container",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: "color-container"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                                            children: tour.title
                                                        })
                                                    ]
                                                }),
                                                tour.address && /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                    className: "info",
                                                    children: [
                                                        tour.address,
                                                        " "
                                                    ]
                                                }),
                                                (tour.beds || tour.showers || tour.cars || tour.accomodation || tour.size) && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                    className: "info",
                                                    style: {
                                                        textIndent: "0",
                                                        padding: 0
                                                    },
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: "amenetis",
                                                        children: [
                                                            tour.beds && /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                                        className: "fas fa-bed"
                                                                    }),
                                                                    " ",
                                                                    tour.beds
                                                                ]
                                                            }),
                                                            tour.showers && /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                                        className: "fas fa-bath"
                                                                    }),
                                                                    " ",
                                                                    tour.showers
                                                                ]
                                                            }),
                                                            tour.cars && /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                                        className: "fas fa-car"
                                                                    }),
                                                                    " ",
                                                                    tour.cars
                                                                ]
                                                            }),
                                                            tour.accomodation && /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                                        className: "fas fa-home"
                                                                    }),
                                                                    " ",
                                                                    tour.accomodation
                                                                ]
                                                            }),
                                                            tour.size && /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                                        className: "fas fa-ruler-combined"
                                                                    }),
                                                                    " ",
                                                                    tour.size,
                                                                    " ",
                                                                    tour.unitSystem === "metric" ? "m2" : "ft"
                                                                ]
                                                            }),
                                                            tour.price && /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                                        className: "fas fa-money-bill-wave"
                                                                    }),
                                                                    " ",
                                                                    tour.price
                                                                ]
                                                            })
                                                        ]
                                                    })
                                                }),
                                                tour.videoUrl && /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                                    className: "square-button video-active",
                                                    onClick: this.toggleVideo.bind(this),
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                            className: "fas fa-video"
                                                        }),
                                                        (ref12 = tour.translation) === null || ref12 === void 0 ? void 0 : ref12.playVideo
                                                    ]
                                                }),
                                                tour.images.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                                    className: tour.videoUrl ? "square-button video-active gallery-button" : "square-button gallery-button",
                                                    onClick: this.toggleGallery.bind(this),
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                            className: "fas fa-images"
                                                        }),
                                                        (ref13 = tour.translation) === null || ref13 === void 0 ? void 0 : ref13.gallery
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(react_slick_lib/* default */.Z, {
                                    className: "main-slider",
                                    infinite: true,
                                    arrows: false,
                                    autoplay: true,
                                    dots: false,
                                    fade: true,
                                    autoplaySpeed: 8000,
                                    speed: 3000,
                                    cssEase: "cubic-bezier(0.7, 0, 0.3, 1)",
                                    children: tour.images.slice(0, 7).map(function(image, i) {
                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "bg",
                                                style: {
                                                    backgroundImage: "url(".concat(_this.props.reactAws, "/tours/").concat(tour.id, "/images/").concat(image.url, ")")
                                                }
                                            })
                                        }, i);
                                    })
                                })
                            ]
                        }),
                        summaryOn && floorPlansOn && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "overview h-610",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "container m-0 w-100 h-100",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "row h-100",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "col-6 p-0 h-100",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "row w-100 m-0",
                                                    style: {
                                                        height: this.state.readMore ? "60%" : "30%"
                                                    },
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(summary_Summary, {
                                                        tour: tour
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "row w-100 m-0",
                                                    ref: function(el) {
                                                        _this.map = el;
                                                    },
                                                    style: {
                                                        height: this.state.readMore ? "40%" : "70%"
                                                    },
                                                    children: tour.address && /*#__PURE__*/ (0,jsx_runtime.jsx)(map_Map, {
                                                        logo: whitelabel === null || whitelabel === void 0 ? void 0 : whitelabel.logo,
                                                        address: tour.address,
                                                        googleKey: this.props.googleKey
                                                    })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "col-6 p-0 h-100",
                                            ref: function(el) {
                                                _this.floorPlans = el;
                                            },
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FloorPlan, {
                                                tour: tour,
                                                switchPlan: this.switchPlan.bind(this),
                                                selectedPlan: this.state.selectedPlan,
                                                imgLong: true,
                                                className: "h-100"
                                            })
                                        })
                                    ]
                                })
                            })
                        }),
                        summaryOn !== floorPlansOn && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "overview h-400",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "container m-0 w-100 h-100",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "row h-100",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "col-6 p-0 h-100",
                                            children: [
                                                summaryOn && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "row h-100 w-100 m-0",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(summary_Summary, {
                                                        tour: tour
                                                    })
                                                }),
                                                floorPlansOn && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "row h-100 w-100 m-0",
                                                    ref: function(el) {
                                                        _this.floorPlans = el;
                                                    },
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FloorPlan, {
                                                        tour: tour,
                                                        switchPlan: this.switchPlan.bind(this),
                                                        selectedPlan: this.state.selectedPlan,
                                                        imgLong: false,
                                                        className: "h-100 w-100"
                                                    })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "col-6 p-0 h-100",
                                            ref: function(el) {
                                                _this.map = el;
                                            },
                                            children: tour.address && /*#__PURE__*/ (0,jsx_runtime.jsx)(map_Map, {
                                                logo: whitelabel === null || whitelabel === void 0 ? void 0 : whitelabel.logo,
                                                address: tour.address,
                                                googleKey: this.props.googleKey
                                            })
                                        })
                                    ]
                                })
                            })
                        }),
                        !summaryOn && !floorPlansOn && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "overview h-400",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "container m-0 w-100 h-100",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "row h-100",
                                    ref: function(el) {
                                        _this.map = el;
                                    },
                                    children: tour.address && /*#__PURE__*/ (0,jsx_runtime.jsx)(map_Map, {
                                        logo: whitelabel === null || whitelabel === void 0 ? void 0 : whitelabel.logo,
                                        address: tour.address,
                                        googleKey: this.props.googleKey
                                    })
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "section tour",
                            ref: function(el) {
                                _this.matterTour = el;
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "clearfix",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                        children: (ref14 = tour.translation) === null || ref14 === void 0 ? void 0 : ref14.threeDTour
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "inner",
                                    children: [
                                        !this.state.play && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "overlay",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "text",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                    alt: "",
                                                    src: "/images/play.svg",
                                                    onClick: function() {
                                                        _this.setState({
                                                            play: true
                                                        });
                                                    }
                                                })
                                            })
                                        }),
                                        !this.state.play && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "bg",
                                            style: {
                                                backgroundImage: "url(".concat(this.props.reactAws, "/tours/").concat(tour.id, "/images/").concat(tour.mainImage, ")")
                                            }
                                        }),
                                        this.state.play && /*#__PURE__*/ (0,jsx_runtime.jsx)(Iframe/* default */.Z, {
                                            logoSrc: whitelabel === null || whitelabel === void 0 ? void 0 : whitelabel.logo,
                                            src: "/".concat(iframeSrcPrefixByTourType, "/").concat(tour.slug, "?messenger=0"),
                                            allowFullscreen: true
                                        })
                                    ]
                                })
                            ]
                        }),
                        !tour.unbranded && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "section contact",
                            ref: function(el) {
                                _this.contact = el;
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "container",
                                    children: tour.contactForm && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "left",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                                children: (ref15 = tour.translation) === null || ref15 === void 0 ? void 0 : ref15.getInTouch
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                        type: "text",
                                                        placeholder: (ref16 = tour.translation) === null || ref16 === void 0 ? void 0 : ref16.name,
                                                        name: "name",
                                                        value: this.state.newLead.name ? this.state.newLead.name : "",
                                                        onChange: this.editLead.bind(this)
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                        type: "text",
                                                        placeholder: (ref17 = tour.translation) === null || ref17 === void 0 ? void 0 : ref17.email,
                                                        name: "email",
                                                        value: this.state.newLead.email ? this.state.newLead.email : "",
                                                        onChange: this.editLead.bind(this)
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                        type: "text",
                                                        placeholder: (ref18 = tour.translation) === null || ref18 === void 0 ? void 0 : ref18.phone,
                                                        name: "phone",
                                                        value: this.state.newLead.phone ? this.state.newLead.phone : "",
                                                        onChange: this.editLead.bind(this)
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                        type: "text",
                                                        placeholder: (ref19 = tour.translation) === null || ref19 === void 0 ? void 0 : ref19.message,
                                                        name: "message",
                                                        value: this.state.newLead.message ? this.state.newLead.message : "",
                                                        onChange: this.editLead.bind(this)
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                        className: "square-button",
                                                        onClick: this.sendLead.bind(this),
                                                        children: (ref20 = tour.translation) === null || ref20 === void 0 ? void 0 : ref20.submit
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "right",
                                    style: !tour.contactForm ? {
                                        width: "100%"
                                    } : {},
                                    children: [
                                        tour.client && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "lg",
                                            children: [
                                                logo && /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                    src: logo,
                                                    alt: ""
                                                }),
                                                tour.client.facebook && /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                    href: tour.client.facebook,
                                                    rel: "noreferrer",
                                                    target: "_blank",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                        className: "fab fa-facebook"
                                                    })
                                                }),
                                                tour.client.instagram && /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                    href: tour.client.instagram,
                                                    rel: "noreferrer",
                                                    target: "_blank",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                        className: "fab fa-instagram"
                                                    })
                                                }),
                                                tour.client.linkedin && /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                    href: tour.client.linkedin,
                                                    rel: "noreferrer",
                                                    target: "_blank",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                        className: "fab fa-linkedin"
                                                    })
                                                }),
                                                tour.client.twitter && /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                    href: tour.client.twitter,
                                                    rel: "noreferrer",
                                                    target: "_blank",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                        className: "fab fa-twitter"
                                                    })
                                                }),
                                                ((ref21 = tour.client) === null || ref21 === void 0 ? void 0 : ref21.website) && /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                    href: ((ref22 = tour.client) === null || ref22 === void 0 ? void 0 : (ref23 = ref22.website) === null || ref23 === void 0 ? void 0 : ref23.includes("https://")) ? tour.client.website : "https://".concat((ref24 = tour.client) === null || ref24 === void 0 ? void 0 : ref24.website),
                                                    rel: "noreferrer",
                                                    target: "_blank",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                        className: "fas fa-globe-americas"
                                                    })
                                                }),
                                                (tour.tourEmail && tour.tourEmail.assertContactIcon || tour.client && tour.client.email) && /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                    href: ((ref25 = tour.tourEmail) === null || ref25 === void 0 ? void 0 : ref25.assertContactIcon) && "mailto:".concat(tour.tourEmail.assertContactIcon) || "mailto:".concat(tour.client.email),
                                                    rel: "noreferrer",
                                                    target: "_blank",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                        className: "fas fa-envelope"
                                                    })
                                                }),
                                                (((ref26 = tour.tourEmail) === null || ref26 === void 0 ? void 0 : ref26.contactPhone) || ((ref27 = tour.client) === null || ref27 === void 0 ? void 0 : ref27.phone)) && /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                    href: "\n                          tel:".concat(((ref28 = tour.tourEmail) === null || ref28 === void 0 ? void 0 : ref28.contactPhone) || ((ref29 = tour.client) === null || ref29 === void 0 ? void 0 : ref29.phone)),
                                                    rel: "noreferrer",
                                                    target: "_blank",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                        className: "fas fa-phone"
                                                    })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "overlay"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "clearfix"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "social",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                    children: (ref30 = tour.translation) === null || ref30 === void 0 ? void 0 : ref30.shareThisPage
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                    rel: "noreferrer",
                                    target: "_blank",
                                    href: "https://www.facebook.com/dialog/share?app_id=".concat(fbAppId || "741048509750318", "&display=popup&href=").concat(encodeURIComponent(window.location.href), "&redirect_uri=").concat(encodeURIComponent(window.location.href)),
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                        className: "fab fa-facebook"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                    rel: "noreferrer",
                                    target: "_blank",
                                    href: "https://twitter.com/intent/tweet?text=".concat(encodeURIComponent(window.location.href)),
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                        className: "fab fa-twitter"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                    rel: "noreferrer",
                                    target: "_blank",
                                    href: "https://wa.me/?text=".concat(encodeURIComponent(window.location.href)),
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                        className: "fab fa-whatsapp"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                    rel: "noreferrer",
                                    target: "_blank",
                                    href: "mailto:?body=".concat(encodeURIComponent(window.location.href)),
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                        className: "fas fa-envelope"
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("footer", {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "container",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                    children: [
                                        (ref31 = tour.translation) === null || ref31 === void 0 ? void 0 : ref31.designedAndDevelopedBy,
                                        " ",
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                            href: whitelabel === null || whitelabel === void 0 ? void 0 : whitelabel.website,
                                            rel: "noreferrer",
                                            target: "_blank",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                src: whitelabel === null || whitelabel === void 0 ? void 0 : whitelabel.logo,
                                                alt: ""
                                            })
                                        })
                                    ]
                                })
                            })
                        })
                    ]
                }),
                tour && !tour.hideCookie && /*#__PURE__*/ (0,jsx_runtime.jsx)(CookieConsent/* CustomCookieConsent */.Le, {
                    tour: tour,
                    loaded: false,
                    message: (ref32 = tour.translation) === null || ref32 === void 0 ? void 0 : ref32.cookieConsentText,
                    accept: (ref33 = tour.translation) === null || ref33 === void 0 ? void 0 : ref33.cookieConsentAccept,
                    decline: (ref34 = tour.translation) === null || ref34 === void 0 ? void 0 : ref34.cookieConsentDecline,
                    messageMandatoryTitle: (ref35 = tour.translation) === null || ref35 === void 0 ? void 0 : ref35.cookieConsentTextMandatoryTitle,
                    messageMandatoryDescription: (ref36 = tour.translation) === null || ref36 === void 0 ? void 0 : ref36.cookieConsentTextMandatoryDescription,
                    acceptMandatory: (ref37 = tour.translation) === null || ref37 === void 0 ? void 0 : ref37.cookieConsentAcceptMandatory,
                    declineMandatory: (ref38 = tour.translation) === null || ref38 === void 0 ? void 0 : ref38.cookieConsentDeclineMandatory
                })
            ]
        });
    };
    return ClassicPublicAsset;
}(react.Component);


// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/useMediaQuery/useMediaQuery.js
var useMediaQuery = __webpack_require__(61225);
// EXTERNAL MODULE: ./node_modules/@mui/system/esm/ThemeProvider/ThemeProvider.js + 2 modules
var ThemeProvider = __webpack_require__(71927);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/styles/createTheme.js + 13 modules
var createTheme = __webpack_require__(74821);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Box/Box.js + 1 modules
var Box = __webpack_require__(61953);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Container/Container.js + 2 modules
var Container = __webpack_require__(36336);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Stack/Stack.js
var Stack = __webpack_require__(9144);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Button/Button.js + 1 modules
var Button = __webpack_require__(54225);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Typography/Typography.js + 1 modules
var Typography = __webpack_require__(29630);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/TextField/TextField.js + 1 modules
var TextField = __webpack_require__(67836);
// EXTERNAL MODULE: ./components-new/index.ts + 3 modules
var components_new = __webpack_require__(48517);
;// CONCATENATED MODULE: ./components/asset/modern/components/ContactAndMap.tsx











var Input = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(TextField/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
        sx: (0,_object_spread/* default */.Z)((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props.sx), {
            "& label": {
                color: "gray"
            },
            "& .MuiOutlinedInput-root": {
                "& fieldset": {
                    borderColor: "gray"
                }
            }
        }), !props.multiline && {
            "& .MuiInputBase-root , input": {
                height: "50px",
                lineHeight: "50px"
            }
        }),
        fullWidth: true
    }));
};
function ContactAndMap(param) {
    var tour = param.tour, isDesktop = param.isDesktop;
    var ref, ref1, ref2;
    var ref3 = (0,react.useState)(""), name = ref3[0], setName = ref3[1];
    var ref4 = (0,react.useState)(""), email = ref4[0], setEmail = ref4[1];
    var ref5 = (0,react.useState)(""), phone = ref5[0], setPhone = ref5[1];
    var ref6 = (0,react.useState)(""), message = ref6[0], setMessage = ref6[1];
    var ref7 = (0,react.useState)(false), submitted = ref7[0], setSubmitted = ref7[1];
    var validatePhone = function(value) {
        var regex = /^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/;
        return regex.test(value);
    };
    var resetForm = function() {
        setName("");
        setEmail("");
        setPhone("");
        setMessage("");
        setSubmitted(false);
    };
    var handleSubmit = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(event) {
            var ref, inputs, tourEmail, client, to, err;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        event.preventDefault();
                        setSubmitted(true);
                        if (!!validatePhone(phone)) return [
                            3,
                            1
                        ];
                        react_toastify_esm/* toast.error */.Am.error("Please enter a valid phone number");
                        return [
                            3,
                            6
                        ];
                    case 1:
                        inputs = {
                            name: name,
                            email: email,
                            phone: phone,
                            message: message,
                            category: TourLead/* LeadCategory.AssertTouchForm */.k.AssertTouchForm,
                            tourId: tour === null || tour === void 0 ? void 0 : tour.id,
                            userId: tour === null || tour === void 0 ? void 0 : tour.userId,
                            link: window.location.href,
                            tour: tour === null || tour === void 0 ? void 0 : tour.title,
                            clientId: tour === null || tour === void 0 ? void 0 : (ref = tour.client) === null || ref === void 0 ? void 0 : ref.id
                        };
                        tourEmail = tour.tourEmail, client = tour.client;
                        to = tourEmail && tourEmail.assertGetInTouch || client && client.email;
                        _state.label = 2;
                    case 2:
                        _state.trys.push([
                            2,
                            5,
                            ,
                            6
                        ]);
                        if (!to) react_toastify_esm/* toast.error */.Am.error("No email to send to");
                        return [
                            4,
                            (0,util/* fetchData */.rQ)("public/sendEmail", "POST", {
                                to: to,
                                params: inputs
                            })
                        ];
                    case 3:
                        _state.sent();
                        react_toastify_esm/* toast.success */.Am.success("E-Mail sent");
                        return [
                            4,
                            (0,util/* fetchData */.rQ)("public/setTourLead", "POST", inputs)
                        ];
                    case 4:
                        _state.sent();
                        resetForm();
                        return [
                            3,
                            6
                        ];
                    case 5:
                        err = _state.sent();
                        console.error(err.message);
                        return [
                            3,
                            6
                        ];
                    case 6:
                        return [
                            2
                        ];
                }
            });
        });
        return function handleSubmit(event) {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
        id: "contact",
        spacing: 3,
        direction: {
            xs: "column-reverse",
            md: "row"
        },
        justifyContent: {
            md: "space-between"
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                sx: {
                    position: "relative",
                    background: "white",
                    borderRadius: "5px",
                    padding: 2
                },
                minWidth: {
                    xs: "100%",
                    md: "50%"
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                variant: "h4",
                                children: ((ref = tour.translation) === null || ref === void 0 ? void 0 : ref.contact) || "Contact us"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                variant: "body1",
                                sx: {
                                    color: "gray",
                                    mb: 2
                                },
                                children: ((ref1 = tour.translation) === null || ref1 === void 0 ? void 0 : ref1.getInTouch) || "Get in touch with us today!"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("form", {
                        onSubmit: handleSubmit,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                            spacing: 2,
                            alignItems: "flex-start",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Input, {
                                    label: "Name",
                                    value: name,
                                    onChange: function(e) {
                                        return setName(e.target.value);
                                    },
                                    required: true
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Input, {
                                    type: "email",
                                    label: "Email",
                                    value: email,
                                    required: true,
                                    onChange: function(e) {
                                        return setEmail(e.target.value);
                                    }
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Input, {
                                    label: "Phone",
                                    value: phone,
                                    error: submitted && !validatePhone(phone),
                                    required: true,
                                    onChange: function(e) {
                                        return setPhone(e.target.value);
                                    }
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Input, {
                                    multiline: true,
                                    rows: 4,
                                    label: "Message",
                                    value: message,
                                    onChange: function(e) {
                                        return setMessage(e.target.value);
                                    },
                                    required: true
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                    fullWidth: !isDesktop,
                                    size: "large",
                                    type: "submit",
                                    variant: "contained",
                                    sx: {
                                        mx: {
                                            xs: "auto !important",
                                            md: "unset !important"
                                        },
                                        color: "white"
                                    },
                                    children: ((ref2 = tour.translation) === null || ref2 === void 0 ? void 0 : ref2.submit) || "Submit"
                                })
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                flexGrow: 1,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_new/* MapResponsive */.lE, {
                    ratio: "1/1",
                    address: tour.address
                })
            })
        ]
    });
}

// EXTERNAL MODULE: ./node_modules/html-react-parser/index.mjs
var html_react_parser = __webpack_require__(25935);
// EXTERNAL MODULE: ./node_modules/@treedis/tour-loader/dist/index.js + 146 modules
var dist = __webpack_require__(59603);
;// CONCATENATED MODULE: ./components/asset/modern/components/Description.tsx
/* eslint-disable no-nested-ternary */ 



var info = [
    {
        property: "accomodation",
        description: "Accomodation<br />Type"
    },
    {
        property: "size",
        description: "Property Size"
    },
    {
        property: "beds",
        description: "Number of<br />Rooms"
    },
    {
        property: "cars",
        description: "Number of<br />Parking places"
    },
    {
        property: "showers",
        description: "Bathrooms"
    },
    {
        property: "price",
        description: "Price"
    }, 
];
var getProperty = function(tour, item) {
    if (!(item === null || item === void 0 ? void 0 : item.property)) return null;
    var property = item.property;
    var propertyValue = tour[property];
    return property === "size" ? "".concat(propertyValue, " ").concat(tour.unitSystem === "metric" ? "m&#178;" : "ft&#178;") : propertyValue;
};
function Description(param) {
    var text = param.text, tour = param.tour;
    var ref;
    if (!tour) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
        spacing: 2,
        children: [
            text && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                        variant: "h5",
                        children: (tour === null || tour === void 0 ? void 0 : (ref = tour.translation) === null || ref === void 0 ? void 0 : ref.description) || "Description"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* ResponsiveText */.lz, {
                        children: (0,html_react_parser/* default */.ZP)(text, dist/* responsiveTextParseOptions */.rZ)
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack/* default */.Z, {
                direction: "row",
                flexWrap: "wrap",
                ml: "-16px !important",
                children: info.map(function(item, index) {
                    return tour[item.property] ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                        spacing: 1,
                        sx: {
                            my: 1,
                            mx: 2
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                variant: "h4",
                                sx: {
                                    fontWeight: "bold"
                                },
                                children: (0,html_react_parser/* default */.ZP)("".concat(getProperty(tour, item) || ""))
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                variant: "body2",
                                component: "span",
                                sx: {
                                    color: "text.secondary",
                                    lineHeight: "15px"
                                },
                                children: (0,html_react_parser/* default */.ZP)(item.description)
                            })
                        ]
                    }, "".concat(tour.id, "-").concat(item.property, "-").concat(index)) : null;
                })
            })
        ]
    });
}

// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Accordion/Accordion.js + 1 modules
var Accordion = __webpack_require__(76992);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/AccordionSummary/AccordionSummary.js + 1 modules
var AccordionSummary = __webpack_require__(29618);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/IconButton/IconButton.js + 1 modules
var IconButton = __webpack_require__(80562);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/AccordionDetails/AccordionDetails.js + 1 modules
var AccordionDetails = __webpack_require__(47028);
;// CONCATENATED MODULE: ./components/asset/modern/components/FloorPlans.tsx







function FloorPlans(param) {
    var tour = param.tour, isDesktop = param.isDesktop;
    var ref;
    var ref1 = (0,react.useState)(), expanded = ref1[0], setExpanded = ref1[1];
    var handleChangeExpanded = function(panel) {
        return function(event, isExpanded) {
            if (event.target.tagName === "BUTTON") return;
            setExpanded(isExpanded ? panel : false);
        };
    };
    var handleDownload = function(floorPlan) {
        return function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function(e) {
                var url;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            e.preventDefault();
                            url = "".concat("https://cdn.treedis.com", "/tours/").concat(tour.id, "/floorplans/").concat(floorPlan.url);
                            return [
                                4,
                                (0,util/* downloadFloorPlan */.fg)(url, floorPlan)
                            ];
                        case 1:
                            _state.sent();
                            return [
                                2
                            ];
                    }
                });
            });
            return function(e) {
                return _ref.apply(this, arguments);
            };
        }();
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack/* default */.Z, {
        spacing: 2,
        id: "floor_plans",
        children: tour === null || tour === void 0 ? void 0 : (ref = tour.floorPlans) === null || ref === void 0 ? void 0 : ref.map(function(floorPlan, index) {
            var ref;
            /*#__PURE__*/ return (0,jsx_runtime.jsxs)(Accordion/* default */.Z, {
                expanded: expanded === floorPlan.id,
                onChange: handleChangeExpanded(floorPlan.id),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(AccordionSummary/* default */.Z, {
                        expandIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                            className: "fa-regular fa-chevron-down"
                        }),
                        sx: {
                            px: 2
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                            direction: "row",
                            width: "100%",
                            justifyContent: "space-between",
                            alignItems: "center",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                    sx: {
                                        overflowWrap: "anywhere"
                                    },
                                    children: floorPlan.name
                                }),
                                isDesktop ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                    startIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                        className: "fas fa-file-pdf"
                                    }),
                                    sx: {
                                        mx: 2
                                    },
                                    onClick: handleDownload(floorPlan),
                                    children: "Download PDF"
                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton/* default */.Z, {
                                    onClick: handleDownload(floorPlan),
                                    sx: {
                                        mx: 2
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                        className: "fa-solid fa-file-arrow-down"
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(AccordionDetails/* default */.Z, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_new/* Image */.Ee, {
                            ratio: "16/9",
                            src: "".concat("https://cdn.treedis.com", "/tours/").concat(tour.id, "/floorplans/").concat(floorPlan === null || floorPlan === void 0 ? void 0 : (ref = floorPlan.url) === null || ref === void 0 ? void 0 : ref.split(".")[0], ".webp"),
                            objectFit: "contain"
                        })
                    })
                ]
            }, index);
        })
    });
}

// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Link/Link.js + 2 modules
var Link = __webpack_require__(68346);
;// CONCATENATED MODULE: ./components-new/common/logo/Logo.tsx


function Logo(param) {
    var href = param.href, src = param.src, _maxHeight = param.maxHeight, maxHeight = _maxHeight === void 0 ? 40 : _maxHeight;
    return src ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(Link/* default */.Z, {
        href: href || "https://www.treedis.com/",
        target: "_blank",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                component: "img",
                src: src,
                sx: {
                    maxHeight: maxHeight,
                    width: "auto",
                    display: "block"
                }
            }),
            " "
        ]
    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
}

;// CONCATENATED MODULE: ./components-new/common/logo/index.ts

/* harmony default export */ var logo = (Logo);

// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Tooltip/Tooltip.js
var Tooltip = __webpack_require__(17575);
// EXTERNAL MODULE: ./node_modules/@mui/system/esm/colorManipulator.js
var colorManipulator = __webpack_require__(41796);
;// CONCATENATED MODULE: ./components/asset/modern/components/navbar/ShareButtons.tsx



var buttons = [
    {
        icon: "fa-brands fa-facebook",
        tooltip: "Facebook",
        href: "https://www.facebook.com/dialog/share?app_id=741048509750318&display=popup&href=".concat(encodeURIComponent(window.location.href), "&redirect_uri=").concat(encodeURIComponent(window.location.href))
    },
    {
        icon: "fa-brands fa-whatsapp",
        tooltip: "Whatsapp",
        href: "https://wa.me/?text=".concat(encodeURIComponent(window.location.href))
    },
    {
        icon: "fa-brands fa-twitter",
        tooltip: "Twitter",
        href: "https://twitter.com/intent/tweet?text=".concat(encodeURIComponent(window.location.href))
    },
    {
        icon: "fa-regular fa-envelope",
        tooltip: "Email",
        href: "mailto:?body=".concat(encodeURIComponent(window.location.href))
    }, 
];
function ShareButtons() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack/* default */.Z, {
        direction: "row",
        children: buttons.map(function(item) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip/* default */.Z, {
                title: item.tooltip,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton/* default */.Z, {
                    component: "a",
                    rel: "noreferrer",
                    target: "_blank",
                    href: item.href,
                    sx: {
                        color: "gray",
                        "&:hover": {
                            color: "black",
                            background: (0,colorManipulator/* alpha */.Fq)("#000", 0.1),
                            textDecoration: "none"
                        }
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                        className: item.icon,
                        style: {
                            fontSize: "16px"
                        }
                    })
                })
            }, item.icon);
        })
    });
}

;// CONCATENATED MODULE: ./components/asset/modern/components/Footer.tsx




function Footer(param) {
    var whitelabel = param.whitelabel;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
        sx: {
            width: "100%",
            px: 2,
            py: 1,
            background: "#fff"
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container/* default */.Z, {
            sx: {
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                flexDirection: {
                    md: "row",
                    xs: "column-reverse"
                }
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                    direction: "row",
                    spacing: 1,
                    alignItems: "center",
                    mt: {
                        md: 0,
                        xs: 1.5
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                            variant: "body2",
                            children: "Powered by"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(logo, {
                            href: whitelabel === null || whitelabel === void 0 ? void 0 : whitelabel.website,
                            src: whitelabel === null || whitelabel === void 0 ? void 0 : whitelabel.logo,
                            maxHeight: 30
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ShareButtons, {})
            ]
        })
    });
}

// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Dialog/Dialog.js + 2 modules
var Dialog = __webpack_require__(31470);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Fab/Fab.js + 1 modules
var Fab = __webpack_require__(10160);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/ButtonBase/ButtonBase.js + 6 modules
var ButtonBase = __webpack_require__(83187);
// EXTERNAL MODULE: ./node_modules/react-device-detect/dist/lib.js
var dist_lib = __webpack_require__(85518);
;// CONCATENATED MODULE: ./components/asset/modern/components/gallery/config.tsx

var getPreviewSettings = function(param) {
    var afterChange = param.afterChange, initialSlide = param.initialSlide;
    return {
        infinite: true,
        speed: 500,
        fade: true,
        slidesToShow: 1,
        initialSlide: initialSlide,
        nextArrow: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
            className: "fa-regular fa-chevron-right"
        }),
        prevArrow: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
            className: "fa-regular fa-chevron-left"
        }),
        afterChange: afterChange
    };
};
var thumbnailsSettings = {
    infinite: true,
    speed: 500,
    slidesToShow: 9,
    swipeToSlide: true,
    centerMode: true,
    responsive: [
        {
            breakpoint: 1500,
            settings: {
                slidesToShow: 6,
                infinite: true
            }
        },
        {
            breakpoint: 1024,
            settings: {
                slidesToShow: 4,
                infinite: true
            }
        },
        {
            breakpoint: 600,
            settings: {
                slidesToShow: 2
            }
        },
        {
            breakpoint: 480,
            settings: {
                slidesToShow: 1
            }
        }, 
    ]
};
var customStyles = {
    height: "90vh",
    ".preview": {
        ".slick-next": {
            right: "15px",
            zIndex: 999
        },
        ".slick-prev": {
            left: "15px",
            zIndex: 999
        },
        ".slick-slider, .slick-list": {
            height: "100%"
        }
    },
    ".thumbs": {
        ".slick-next": {
            right: "10px",
            zIndex: 999
        },
        ".slick-prev": {
            left: "10px",
            zIndex: 999
        },
        ".slick-slide>div": {
            marginX: 1
        }
    },
    ".slick-prev:before, .slick-next:before": {
        fontSize: "40px !important",
        opacity: 1
    },
    ".slick-prev, .slick-next": {
        width: 40,
        height: 40
    }
};

;// CONCATENATED MODULE: ./components/asset/modern/components/gallery/GalleryDrawer.tsx













function GalleryDrawer(param) {
    var open = param.open, images = param.images, index = param.index, tour = param.tour, onClose = param.onClose;
    var ref, ref1;
    var isMobileLandscape = (0,useMediaQuery/* default */.Z)("(orientation: landscape)") && dist_lib/* isMobile */.tq;
    var previewRef = (0,react.useRef)(null);
    var ref2 = (0,react.useState)(index), previewIndex = ref2[0], setPreviewIndex = ref2[1];
    var previewSettings = getPreviewSettings({
        afterChange: function(i) {
            return setPreviewIndex(i);
        },
        initialSlide: index
    });
    var downloadCurrentImage = function(url) {
        return function() {
            react_toastify_esm/* toast.promise */.Am.promise((0,_async_to_generator/* default */.Z)(function() {
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                downloadImage(url, tour)
                            ];
                        case 1:
                            _state.sent();
                            return [
                                2
                            ];
                    }
                });
            })(), {
                pending: "Preparing image for download...",
                success: "Download complete!",
                error: "Download failed!"
            });
        };
    };
    var downloadAll = (0,react.useCallback)(function() {
        react_toastify_esm/* toast.promise */.Am.promise((0,_async_to_generator/* default */.Z)(function() {
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            downloadAllImages(images, tour)
                        ];
                    case 1:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        })(), {
            pending: "Preparing images for download...",
            success: "Download complete!",
            error: "Download failed!"
        });
    }, [
        images,
        tour
    ]);
    var handleThumbnailClick = function(idx) {
        return function() {
            previewRef.current.slickGoTo(idx);
        };
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Dialog/* default */.Z, {
        className: "lightbox",
        open: open,
        onClose: onClose,
        fullScreen: true,
        PaperProps: {
            style: {
                backgroundColor: "#000",
                boxShadow: "none",
                overflow: "hidden",
                justifyContent: "center"
            }
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Fab/* default */.Z, {
                size: "small",
                onClick: onClose,
                sx: {
                    background: "white",
                    boxShadow: "none",
                    position: "fixed",
                    top: "15px",
                    right: "15px",
                    zIndex: 999
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                    className: "fa-regular fa-times",
                    style: {
                        fontSize: "20px"
                    }
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                direction: "column",
                spacing: 4,
                justifyContent: isMobileLandscape ? "center" : "space-between",
                sx: customStyles,
                children: [
                    !isMobileLandscape && /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                        className: "preview",
                        position: "relative",
                        sx: {
                            maxHeight: isMobileLandscape ? "100vh" : "70vh",
                            ".slick-track": {
                                height: "100%",
                                display: "flex"
                            },
                            ".slick-track .slick-slide": {
                                display: "flex",
                                height: "auto",
                                alignItems: "center",
                                justifyContent: "center"
                            }
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(react_slick_lib/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                                ref: previewRef
                            }, previewSettings), {
                                children: images.map(function(img, idx) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                        src: img,
                                        alt: "preview"
                                    }, idx);
                                })
                            })),
                            tour.client && tour.client.watermark && /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                component: "img",
                                sx: {
                                    position: "absolute",
                                    top: "50%",
                                    left: "50%",
                                    transform: "translate(-50%, -50%)",
                                    zIndex: 99,
                                    opacity: 0.5,
                                    width: "200px",
                                    maxWidth: "30vw",
                                    maxHeight: "50vh",
                                    objectFit: "contain"
                                },
                                src: "".concat("https://cdn.treedis.com", "/clients/").concat(tour.client.id, "/watermark.png").concat((0,util/* getVersion */.bo)(tour.client.updatedAt))
                            }),
                            ((ref = tour.client) === null || ref === void 0 ? void 0 : ref.logo) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                component: "img",
                                sx: {
                                    position: "absolute",
                                    top: "20px",
                                    left: "20px",
                                    zIndex: 99,
                                    width: ((ref1 = tour.client) === null || ref1 === void 0 ? void 0 : ref1.widthLogo) ? "250px" : "150px",
                                    maxWidth: "20vw",
                                    objectFit: "contain"
                                },
                                src: "".concat("https://cdn.treedis.com", "/clients/").concat(tour.client.id, "/logo.png").concat((0,util/* getVersion */.bo)(tour.client.updatedAt))
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                                zIndex: 999,
                                direction: "row",
                                sx: {
                                    position: "absolute",
                                    bottom: 10,
                                    right: 25
                                },
                                spacing: 1,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip/* default */.Z, {
                                        title: "Download all",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Fab/* default */.Z, {
                                            size: "small",
                                            onClick: downloadAll,
                                            sx: {
                                                background: "white",
                                                boxShadow: "none"
                                            },
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                className: "fa-regular fa-folder-arrow-down",
                                                style: {
                                                    fontSize: "20px"
                                                }
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip/* default */.Z, {
                                        title: "Download current",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Fab/* default */.Z, {
                                            size: "small",
                                            onClick: downloadCurrentImage(images[previewIndex]),
                                            sx: {
                                                background: "white",
                                                boxShadow: "none"
                                            },
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                className: "fa-regular fa-file-arrow-down",
                                                style: {
                                                    fontSize: "20px"
                                                }
                                            })
                                        })
                                    })
                                ]
                            })
                        ]
                    }),
                    !isMobileLandscape && /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                        className: "thumbs",
                        sx: {
                            paddingX: 2
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_slick_lib/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, thumbnailsSettings), {
                            children: images.map(function(i, idx) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonBase/* default */.Z, {
                                    onClick: handleThumbnailClick(idx),
                                    sx: {
                                        height: "100px",
                                        backgroundImage: "url(".concat(i, ")"),
                                        backgroundSize: "cover",
                                        backgroundOrigin: "padding-box",
                                        paddingX: 1,
                                        borderRadius: "5px",
                                        overflow: "hidden",
                                        opacity: idx === previewIndex ? ".6" : 1
                                    }
                                }, idx);
                            })
                        }))
                    })
                ]
            })
        ]
    });
}

// EXTERNAL MODULE: ./node_modules/react-player/lib/index.js
var react_player_lib = __webpack_require__(22004);
;// CONCATENATED MODULE: ./components/asset/modern/components/gallery/GalleryThumbnails.tsx





function GalleryThumbnails(param) {
    var gallery = param.gallery, tour = param.tour, onClick = param.onClick;
    var ref;
    var videoUrl = (0,util/* getVideoLink */.rp)(tour.videoUrl);
    var hasVideo = Boolean(videoUrl) && false;
    var showViewMore = gallery.length > (hasVideo ? 4 : 5);
    var galleryThumbs = hasVideo ? gallery.slice(0, 3) : gallery.slice(1, showViewMore ? 4 : 5);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
        py: 2,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
            sx: {
                display: "grid",
                gap: 1,
                gridTemplateColumns: {
                    xs: "repeat(1, 1fr)",
                    md: "repeat(2, 1fr)"
                }
            },
            children: [
                hasVideo ? /*#__PURE__*/ (0,jsx_runtime.jsx)(components_new/* ResponsiveContainer */.h2, {
                    ratio: "1/1",
                    containerStyles: {
                        borderRadius: 2,
                        overflow: "hidden"
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_player_lib/* default */.Z, {
                        width: "100%",
                        height: "100%",
                        controls: true,
                        url: videoUrl
                    })
                }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                    position: "relative",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(components_new/* Image */.Ee, {
                            alt: "photo",
                            src: gallery[0],
                            ratio: "1/1",
                            objectFit: "cover",
                            onClick: function() {
                                return onClick(0);
                            },
                            sx: {
                                borderRadius: 2,
                                cursor: "pointer",
                                "&:hover": {
                                    opacity: 0.8
                                }
                            }
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                            sx: {
                                position: "absolute",
                                bottom: 0,
                                left: 0,
                                right: 0,
                                paddingX: 4,
                                paddingY: 2,
                                color: "#fff",
                                borderRadius: "0 0 5px 5px",
                                background: "rgba(0,0,0,0.5)",
                                backdropFilter: "blur(2px)"
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                    variant: "h3",
                                    children: tour === null || tour === void 0 ? void 0 : tour.title
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                                    variant: "h6",
                                    fontWeight: "lighter",
                                    sx: {
                                        mt: "0 !important"
                                    },
                                    children: [
                                        tour === null || tour === void 0 ? void 0 : (ref = tour.images) === null || ref === void 0 ? void 0 : ref.length,
                                        " Pictures"
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                    sx: {
                        display: "grid",
                        gap: 1,
                        gridTemplateColumns: "repeat(2, 1fr)"
                    },
                    children: [
                        galleryThumbs.map(function(photo, index) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(components_new/* Image */.Ee, {
                                alt: "photo",
                                src: photo,
                                ratio: "1/1",
                                objectFit: "cover",
                                onClick: function() {
                                    return onClick(index + 1);
                                },
                                sx: {
                                    borderRadius: 2,
                                    cursor: "pointer",
                                    "&:hover": {
                                        opacity: 0.8
                                    }
                                }
                            }, photo);
                        }),
                        gallery.length > (hasVideo ? 4 : 5) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                            position: "relative",
                            sx: {
                                borderRadius: 2,
                                overflow: "hidden"
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(components_new/* Image */.Ee, {
                                    alt: "photo",
                                    src: gallery[hasVideo ? 3 : 4],
                                    ratio: "1/1",
                                    objectFit: "cover",
                                    sx: {
                                        borderRadius: 2,
                                        cursor: "pointer",
                                        "&:hover": {
                                            opacity: 0.8
                                        }
                                    }
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                    onClick: function() {
                                        return onClick(4);
                                    },
                                    sx: {
                                        position: "absolute",
                                        top: 0,
                                        left: 0,
                                        right: 0,
                                        bottom: 0,
                                        color: "#fff",
                                        background: "rgba(0,0,0,0.5)",
                                        backdropFilter: "blur(2px)",
                                        "&:hover": {
                                            background: "rgba(0,0,0,0.5)",
                                            opacity: 0.8
                                        }
                                    },
                                    startIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                        className: "fa-regular fa-eye"
                                    }),
                                    children: "View more"
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
}

;// CONCATENATED MODULE: ./components/asset/modern/components/gallery/Gallery.tsx







function Gallery(param) {
    var tour = param.tour;
    var ref;
    var ref1 = (0,react.useState)(false), open = ref1[0], setOpen = ref1[1];
    var ref2 = (0,react.useState)([]), images = ref2[0], setImages = ref2[1];
    var ref3 = (0,react.useState)(0), index = ref3[0], setIndex = ref3[1];
    (0,react.useEffect)(function() {
        if (tour === null || tour === void 0 ? void 0 : tour.id) {
            (0,util/* fetchData */.rQ)("public/getAllTourImages", "POST", {
                id: tour.id
            }).then(function(data) {
                if (!data.images) {
                    react_toastify_esm/* toast.error */.Am.error("Couldn't load images");
                } else {
                    var imgs = data.images.map(function(img) {
                        return "".concat("https://cdn.treedis.com", "/tours/").concat(tour.id, "/images/").concat(img.url);
                    });
                    setImages(imgs);
                }
            }).catch(function(err) {
                console.error(err.message);
            });
        }
    }, [
        tour === null || tour === void 0 ? void 0 : tour.id
    ]);
    var handleThumbnailClick = function(i) {
        setOpen(true);
        setIndex(i);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
        id: "gallery",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                variant: "h5",
                children: (tour === null || tour === void 0 ? void 0 : (ref = tour.translation) === null || ref === void 0 ? void 0 : ref.gallery) || "Gallery"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(GalleryThumbnails, {
                gallery: images,
                tour: tour,
                onClick: handleThumbnailClick
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(GalleryDrawer, {
                images: images,
                tour: tour,
                open: open,
                onClose: function() {
                    return setOpen(false);
                },
                index: index
            })
        ]
    });
}

// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Chip/Chip.js + 2 modules
var Chip = __webpack_require__(21448);
;// CONCATENATED MODULE: ./components/asset/modern/components/VolumeControls.tsx


function isTouchDevice() {
    return "ontouchstart" in window || navigator.maxTouchPoints;
}
function VolumeControls(param) {
    var videoUrl = param.videoUrl, muted = param.muted, setMuted = param.setMuted;
    var isTouch = isTouchDevice();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
        id: "volume-controls",
        direction: "row",
        spacing: 1,
        alignItems: "center",
        sx: {
            position: "absolute",
            top: "16px",
            left: "16px",
            padding: "2px",
            zIndex: 99,
            background: "rgba(0,0,0,0.4)",
            borderRadius: "50px",
            opacity: isTouch ? 1 : 0
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton/* default */.Z, {
                sx: {
                    color: "#fff",
                    transition: "all 0.3s ease-in-out",
                    height: "37px",
                    width: "37px",
                    "&:hover": {
                        background: "rgba(0,0,0,0.4)"
                    }
                },
                onClick: function() {
                    return setMuted(!muted);
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                    className: "far ".concat(muted ? "fa-volume-slash" : "fa-volume", " fa-fw")
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Chip/* default */.Z, {
                    component: Link/* default */.Z,
                    target: "_blank",
                    href: videoUrl,
                    sx: {
                        boxShadow: "none",
                        color: "#fff",
                        fontWeight: "bolder",
                        cursor: "pointer",
                        background: "transparent",
                        transition: "all 0.3s ease-in-out",
                        height: "37px",
                        borderRadius: "50px",
                        "&:hover": {
                            textDecoration: "none",
                            color: "#fff",
                            background: "rgba(0,0,0,0.4)"
                        }
                    },
                    label: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                        direction: "row",
                        alignItems: "center",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                sx: {
                                    fontSize: "15px"
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                    className: "fas fa-arrow-up-right-from-square fa-fw"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                variant: "body1",
                                sx: {
                                    color: "#fff",
                                    mx: 1
                                },
                                children: "Open"
                            })
                        ]
                    })
                })
            })
        ]
    });
}

;// CONCATENATED MODULE: ./components/asset/modern/components/Header.tsx







function Header(param) {
    var tour = param.tour, isDesktop = param.isDesktop;
    var ref, ref1, ref2;
    var videoUrl = tour.videoUrl;
    var ref3 = (0,react.useState)(true), muted = ref3[0], setMuted = ref3[1];
    var handleClick = function(id) {
        return function() {
            var el = document.getElementById(id);
            if (el) {
                el.scrollIntoView({
                    behavior: "smooth",
                    block: "center",
                    inline: "nearest"
                });
            }
        };
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(components_new/* ResponsiveContainer */.h2, {
        ratio: isDesktop ? "16/9" : "cover",
        containerStyles: {
            borderRadius: "5px",
            overflow: "hidden",
            marginTop: "70px",
            position: "relative",
            "&:hover": {
                "& #volume-controls": {
                    transition: "all 0.3s ease-in-out",
                    opacity: 1
                }
            }
        },
        children: [
            videoUrl && /*#__PURE__*/ (0,jsx_runtime.jsx)(VolumeControls, {
                videoUrl: videoUrl,
                muted: muted,
                setMuted: setMuted
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                position: "relative",
                id: "overview",
                width: "100%",
                height: "100%",
                sx: {
                    ".slick-slider, .slick-list, .slick-track, .slick-slide, .slick-slide>div, .slick-slide>div>img": {
                        height: "100%",
                        objectFit: "cover"
                    }
                },
                children: [
                    videoUrl ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                        width: "100%",
                        height: "100%",
                        sx: {
                            pointerEvents: "none",
                            position: "relative"
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_player_lib/* default */.Z, {
                            width: "100%",
                            height: "100%",
                            controls: false,
                            url: videoUrl,
                            muted: muted,
                            volume: 1,
                            playing: true,
                            loop: true,
                            config: {
                                youtube: {
                                    playerVars: {
                                        disablekb: 1,
                                        controls: 0,
                                        showinfo: 0,
                                        frameborder: 0,
                                        title: 0,
                                        modestbranding: 0
                                    }
                                }
                            }
                        })
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(react_slick_lib/* default */.Z, {
                        infinite: true,
                        arrows: false,
                        autoplay: true,
                        dots: false,
                        fade: true,
                        autoplaySpeed: 5000,
                        speed: 2000,
                        cssEase: "cubic-bezier(0.7, 0, 0.3, 1)",
                        children: tour === null || tour === void 0 ? void 0 : (ref = tour.images) === null || ref === void 0 ? void 0 : ref.slice(1, 7).map(function(image, i) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                component: "img",
                                src: "".concat("https://cdn.treedis.com", "/tours/").concat(tour.id, "/images/").concat(image.url)
                            }, i);
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack/* default */.Z, {
                        sx: {
                            background: "rgba(0,0,0,0.5)",
                            position: "absolute",
                            bottom: 0,
                            left: 0,
                            right: 0,
                            padding: 2,
                            color: "#fff",
                            borderRadius: isDesktop ? "0 0 5px 5px" : "0",
                            backdropFilter: "blur(2px)"
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                            direction: {
                                xs: "column",
                                md: "row"
                            },
                            justifyContent: "space-between",
                            spacing: 1,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                                    spacing: 1,
                                    justifyContent: "center",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                            variant: "h3",
                                            children: tour === null || tour === void 0 ? void 0 : tour.title
                                        }),
                                        (tour === null || tour === void 0 ? void 0 : tour.description) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                            variant: "h6",
                                            fontWeight: "lighter",
                                            sx: {
                                                display: "-webkit-box",
                                                WebkitBoxOrient: "vertical",
                                                WebkitLineClamp: 2,
                                                overflow: "hidden",
                                                textOverflow: "ellipsis",
                                                overflowWrap: "break-word"
                                            },
                                            children: tour === null || tour === void 0 ? void 0 : tour.description
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack/* default */.Z, {
                                    direction: "row",
                                    alignItems: "center",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                                        minWidth: 220,
                                        textAlign: isDesktop ? "right" : "left",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                                variant: "contained",
                                                color: "primary",
                                                size: isDesktop ? "large" : "medium",
                                                sx: {
                                                    color: "#fff",
                                                    mr: 2
                                                },
                                                onClick: handleClick("gallery"),
                                                children: (tour === null || tour === void 0 ? void 0 : (ref1 = tour.translation) === null || ref1 === void 0 ? void 0 : ref1.gallery) || "Gallery"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                                variant: "contained",
                                                color: "primary",
                                                size: isDesktop ? "large" : "medium",
                                                sx: {
                                                    color: "#fff"
                                                },
                                                onClick: handleClick("3_d_tour"),
                                                children: (tour === null || tour === void 0 ? void 0 : (ref2 = tour.translation) === null || ref2 === void 0 ? void 0 : ref2.threeDTour) || "3D Tour"
                                            })
                                        ]
                                    })
                                })
                            ]
                        })
                    })
                ]
            })
        ]
    });
}

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/CircularProgress/CircularProgress.js + 1 modules
var CircularProgress = __webpack_require__(70754);
// EXTERNAL MODULE: ./utils/getRatio.ts
var getRatio = __webpack_require__(19245);
;// CONCATENATED MODULE: ./components/asset/modern/components/IframeResponsive.tsx
// @ts-nocheck







function IframeResponsive(_param) {
    var ratio = _param.ratio, sx = _param.sx, src = _param.src, previewSrc = _param.previewSrc, whitelabel = _param.whitelabel, other = (0,_object_without_properties/* default */.Z)(_param, [
        "ratio",
        "sx",
        "src",
        "previewSrc",
        "whitelabel"
    ]);
    var ref = (0,react.useState)(false), play = ref[0], setPlay = ref[1];
    var ref1 = (0,react.useState)(false), loading = ref1[0], setLoading = ref1[1];
    var ref2 = (0,react.useState)(true), fullScreen = ref2[0], setFullScreen = ref2[1];
    (0,react.useEffect)(function() {
        var handleKeyDown = function handleKeyDown(event) {
            if (event.key === "Escape") {
                setFullScreen(false);
            }
        };
        if (fullScreen) {
            document.addEventListener("keydown", handleKeyDown);
        }
        return function() {
            document.removeEventListener("keydown", handleKeyDown);
        };
    }, [
        fullScreen
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
        id: "3_d_tour",
        sx: {
            borderRadius: "5px",
            overflow: "hidden"
        },
        children: [
            (!play || loading) && /*#__PURE__*/ (0,jsx_runtime.jsx)(components_new/* Image */.Ee, {
                alt: "hero",
                src: previewSrc,
                ratio: ratio,
                overComponent: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton/* default */.Z, {
                    sx: {
                        position: "absolute",
                        top: "50%",
                        left: "50%",
                        transform: "translate(-50%, -50%)",
                        color: "#fff",
                        borderRadius: "50%",
                        fontSize: "77px",
                        width: "77px",
                        height: "77px",
                        zIndex: 9,
                        ".fa-duotone:after": {
                            opacity: 1
                        }
                    },
                    onClick: function() {
                        setLoading(true);
                        setPlay(true);
                    },
                    children: loading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(CircularProgress/* default */.Z, {
                        size: 50
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                        className: "fas fa-circle-play",
                        style: {
                            "--fa-primary-color": "#fff",
                            "--fa-secondary-color": (whitelabel === null || whitelabel === void 0 ? void 0 : whitelabel.primaryColor) || "#2055ff"
                        }
                    })
                })
            }),
            play && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                component: "span",
                sx: (0,_object_spread/* default */.Z)({
                    width: 1,
                    lineHeight: 1,
                    display: "block",
                    overflow: "hidden",
                    position: "relative",
                    pt: loading ? "0" : (0,getRatio/* default */.Z)(ratio),
                    "& .wrapper": {
                        top: 0,
                        left: 0,
                        right: 0,
                        bottom: 0,
                        lineHeight: 0,
                        position: fullScreen ? "fixed" : "absolute",
                        zIndex: fullScreen ? 999 : 0,
                        backgroundSize: "cover !important"
                    }
                }, sx),
                children: [
                    !loading && /*#__PURE__*/ (0,jsx_runtime.jsx)(Fab/* default */.Z, {
                        size: "small",
                        onClick: function() {
                            return setFullScreen(function(prev) {
                                return !prev;
                            });
                        },
                        sx: {
                            background: "white",
                            boxShadow: "none",
                            position: fullScreen ? "fixed" : "absolute",
                            bottom: "12px",
                            right: "10px",
                            zIndex: 9999
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                            className: "fa-regular ".concat(fullScreen ? "fa-compress" : "fa-expand"),
                            style: {
                                fontSize: "20px"
                            }
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                        className: "wrapper",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("iframe", (0,_object_spread/* default */.Z)({
                            src: src,
                            style: {
                                width: "100%",
                                height: "100%"
                            },
                            onLoad: function() {
                                return setLoading(false);
                            }
                        }, other))
                    })
                ]
            })
        ]
    });
}

// EXTERNAL MODULE: ./node_modules/@mui/material/esm/AppBar/AppBar.js + 1 modules
var AppBar = __webpack_require__(85050);
// EXTERNAL MODULE: ./node_modules/lodash/lodash.js
var lodash = __webpack_require__(96486);
;// CONCATENATED MODULE: ./components/asset/modern/components/navbar/NavDesktop.tsx




function NavDesktop(param) {
    var setSection = param.setSection, pages = param.pages;
    var handleClick = function(id) {
        var el = document.getElementById(id);
        if (el) {
            el.scrollIntoView({
                behavior: "smooth",
                block: "center",
                inline: "nearest"
            });
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack/* default */.Z, {
        direction: "row",
        spacing: 2,
        children: pages.map(function(page) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                onClick: function() {
                    var id = (0,lodash.snakeCase)(page.key);
                    if (page.key === "Floor Plans" || page.key === "3D Tour") {
                        setSection(id);
                    }
                    setTimeout(function() {
                        handleClick(id);
                    }, 0);
                },
                sx: {
                    color: "gray",
                    textTransform: "unset",
                    "&:hover": {
                        color: "black",
                        background: (0,colorManipulator/* alpha */.Fq)("#000", 0.1)
                    }
                },
                children: page.label
            }, page.key);
        })
    });
}

// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Drawer/Drawer.js + 1 modules
var Drawer = __webpack_require__(60684);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/List/List.js + 1 modules
var List = __webpack_require__(85214);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/ListItemButton/ListItemButton.js + 1 modules
var ListItemButton = __webpack_require__(45982);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/ListItemText/ListItemText.js
var ListItemText = __webpack_require__(61702);
;// CONCATENATED MODULE: ./components/asset/modern/components/navbar/NavMobile.tsx





var DRAWER_WIDTH = 280;
function NavMobile(param) {
    var whitelabel = param.whitelabel, pages = param.pages, setSection = param.setSection;
    var ref = (0,react.useState)(false), drawerOpen = ref[0], setDrawerOpen = ref[1];
    var handleDrawerOpen = function() {
        setDrawerOpen(true);
    };
    var handleDrawerClose = function() {
        setDrawerOpen(false);
    };
    var handleClick = function(id) {
        var el = document.getElementById(id);
        if (el) {
            el.scrollIntoView({
                behavior: "smooth",
                block: "center",
                inline: "nearest"
            });
            handleDrawerClose();
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                endIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                    className: "fas fa-bars"
                }),
                onClick: handleDrawerOpen,
                children: "Menu"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Drawer/* default */.ZP, {
                open: drawerOpen,
                onClose: handleDrawerClose,
                ModalProps: {
                    keepMounted: true
                },
                PaperProps: {
                    sx: {
                        width: DRAWER_WIDTH
                    }
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                        sx: {
                            px: 2.5,
                            py: 3,
                            lineHeight: 0
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(logo, {
                            src: whitelabel === null || whitelabel === void 0 ? void 0 : whitelabel.logo
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(List/* default */.Z, {
                        sx: {
                            px: 0
                        },
                        children: pages.map(function(page) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(ListItemButton/* default */.Z, {
                                sx: {
                                    px: 2.5,
                                    py: 1.5
                                },
                                onClick: function() {
                                    var id = (0,lodash.snakeCase)(page.key);
                                    if (page.key === "Floor Plans" || page.key === "3D Tour") {
                                        setSection(id);
                                    }
                                    setTimeout(function() {
                                        handleClick(id);
                                    }, 0);
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ListItemText/* default */.Z, {
                                    disableTypography: true,
                                    primary: page.label
                                })
                            }, page.key);
                        })
                    })
                ]
            })
        ]
    });
}

;// CONCATENATED MODULE: ./components/asset/modern/components/navbar/Navbar.tsx






function Navbar(param) {
    var whitelabel = param.whitelabel, setSection = param.setSection, isDesktop = param.isDesktop, hasFloorPlans = param.hasFloorPlans, translation = param.translation;
    var ref = [
        {
            key: "Overview",
            label: translation.overview
        },
        {
            key: "Gallery",
            label: translation === null || translation === void 0 ? void 0 : translation.gallery
        },
        {
            key: "3D Tour",
            label: translation === null || translation === void 0 ? void 0 : translation.threeDTour
        },
        {
            key: "Floor Plans",
            label: translation === null || translation === void 0 ? void 0 : translation.floorPlans
        },
        {
            key: "Contact",
            label: translation === null || translation === void 0 ? void 0 : translation.contact
        }, 
    ], overview = ref[0], gallery = ref[1], tour = ref[2], floorPlans = ref[3], contact = ref[4];
    var pages = hasFloorPlans ? [
        overview,
        gallery,
        tour,
        floorPlans,
        contact
    ] : [
        overview,
        gallery,
        tour,
        contact
    ];
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(AppBar/* default */.Z, {
        sx: {
            background: "#fff",
            opacity: 1,
            top: 0,
            zIndex: 999,
            justifyContent: "center",
            boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.05)"
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container/* default */.Z, {
            sx: {
                display: "flex",
                alignItems: "center",
                justifyContent: "flex-start"
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(logo, {
                    href: whitelabel === null || whitelabel === void 0 ? void 0 : whitelabel.website,
                    src: whitelabel === null || whitelabel === void 0 ? void 0 : whitelabel.logo
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                    sx: {
                        flexGrow: 1
                    }
                }),
                isDesktop && /*#__PURE__*/ (0,jsx_runtime.jsx)(NavDesktop, {
                    setSection: setSection,
                    pages: pages
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                    sx: {
                        flexGrow: 1
                    }
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack/* default */.Z, {
                    spacing: 2,
                    direction: "row",
                    alignItems: "center",
                    children: isDesktop && /*#__PURE__*/ (0,jsx_runtime.jsx)(ShareButtons, {})
                }),
                !isDesktop && /*#__PURE__*/ (0,jsx_runtime.jsx)(NavMobile, {
                    whitelabel: whitelabel,
                    pages: pages,
                    setSection: setSection
                })
            ]
        })
    });
}

;// CONCATENATED MODULE: ./components/asset/modern/components/Summary.tsx




function Summary_Summary(param) {
    var text = param.text, tour = param.tour;
    var ref;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
        spacing: 2,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                variant: "h5",
                children: (tour === null || tour === void 0 ? void 0 : (ref = tour.translation) === null || ref === void 0 ? void 0 : ref.summary) || "Summary"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* ResponsiveText */.lz, {
                children: (0,html_react_parser/* default */.ZP)(text, dist/* responsiveTextParseOptions */.rZ)
            })
        ]
    });
}

;// CONCATENATED MODULE: ./components/asset/modern/theme/overrides/Accordion.tsx
// ----------------------------------------------------------------------
function Accordion_Accordion() {
    return {
        MuiAccordion: {
            styleOverrides: {
                root: {
                    borderRadius: "5px !important",
                    boxShadow: "none !important",
                    backgroundColor: "#ebebeb",
                    "&:before": {
                        display: "none"
                    }
                }
            }
        }
    };
}

;// CONCATENATED MODULE: ./components/asset/modern/theme/overrides/Button.ts
function Button_Button() {
    return {
        MuiButton: {
            styleOverrides: {
                root: {
                    fontSize: "14px",
                    boxShadow: "none"
                },
                sizeLarge: {
                    height: "56px"
                }
            }
        }
    };
}

;// CONCATENATED MODULE: ./components/asset/modern/theme/overrides/index.ts



function ComponentsOverrides() {
    return (0,lodash.merge)(Accordion_Accordion(), Button_Button());
}

;// CONCATENATED MODULE: ./components/asset/modern/theme/typography.ts

function pxToRem(value) {
    return "".concat(value / 16, "rem");
}
function responsiveFontSizes(param) {
    var sm = param.sm, md = param.md, lg = param.lg;
    return {
        "@media (min-width:600px)": {
            fontSize: pxToRem(sm)
        },
        "@media (min-width:900px)": {
            fontSize: pxToRem(md)
        },
        "@media (min-width:1200px)": {
            fontSize: pxToRem(lg)
        }
    };
}
var FONT_PRIMARY = "Public Sans, sans-serif"; // Google Font
var typography = {
    fontFamily: FONT_PRIMARY,
    fontWeightRegular: 400,
    fontWeightMedium: 600,
    fontWeightBold: 700,
    h1: (0,_object_spread/* default */.Z)({
        fontWeight: 700,
        lineHeight: 80 / 64,
        fontSize: pxToRem(40)
    }, responsiveFontSizes({
        sm: 52,
        md: 58,
        lg: 64
    })),
    h2: (0,_object_spread/* default */.Z)({
        fontWeight: 700,
        lineHeight: 64 / 48,
        fontSize: pxToRem(32)
    }, responsiveFontSizes({
        sm: 40,
        md: 44,
        lg: 48
    })),
    h3: (0,_object_spread/* default */.Z)({
        fontWeight: 700,
        lineHeight: 1.5,
        fontSize: pxToRem(24)
    }, responsiveFontSizes({
        sm: 26,
        md: 30,
        lg: 32
    })),
    h4: (0,_object_spread/* default */.Z)({
        fontWeight: 700,
        lineHeight: 1.5,
        fontSize: pxToRem(20)
    }, responsiveFontSizes({
        sm: 20,
        md: 24,
        lg: 24
    })),
    h5: (0,_object_spread/* default */.Z)({
        fontWeight: 700,
        lineHeight: 1.5,
        fontSize: pxToRem(18)
    }, responsiveFontSizes({
        sm: 19,
        md: 20,
        lg: 20
    })),
    h6: (0,_object_spread/* default */.Z)({
        fontWeight: 700,
        lineHeight: 28 / 18,
        fontSize: pxToRem(17)
    }, responsiveFontSizes({
        sm: 16,
        md: 18,
        lg: 18
    })),
    subtitle1: {
        fontWeight: 600,
        lineHeight: 1.5,
        fontSize: pxToRem(16)
    },
    subtitle2: {
        fontWeight: 600,
        lineHeight: 22 / 14,
        fontSize: pxToRem(14)
    },
    body1: {
        lineHeight: 1.5,
        fontSize: pxToRem(16)
    },
    body2: {
        lineHeight: 22 / 14,
        fontSize: pxToRem(14)
    },
    caption: {
        lineHeight: 1.5,
        fontSize: pxToRem(12)
    },
    overline: {
        fontWeight: 700,
        lineHeight: 1.5,
        fontSize: pxToRem(12),
        letterSpacing: 1.1,
        textTransform: "uppercase"
    },
    button: {
        fontWeight: 700,
        lineHeight: 24 / 14,
        fontSize: pxToRem(14),
        textTransform: "capitalize"
    }
};
/* harmony default export */ var theme_typography = (typography);

// EXTERNAL MODULE: ./utils/muiColor.ts + 5 modules
var muiColor = __webpack_require__(14361);
;// CONCATENATED MODULE: ./components/asset/modern/ModernPublicAsset.tsx


















function ModernPublicAsset(param) {
    var whitelabel = param.whitelabel, tour = param.tour;
    var ref, ref1, ref2, ref3;
    var ref4 = (0,react.useState)("3_d_tour"), section = ref4[0], setSection = ref4[1];
    var isDesktop = (0,useMediaQuery/* default */.Z)(function(theme) {
        return theme.breakpoints.up("md");
    });
    var iframeSrcPrefixByTourType = Tour/* TourTypeURL */.YO[tour.mode];
    var hasFloorPlans = (tour === null || tour === void 0 ? void 0 : tour.floorPlansEnabled) && !!(tour === null || tour === void 0 ? void 0 : (ref = tour.floorPlans) === null || ref === void 0 ? void 0 : ref.length);
    var primaryColor = (whitelabel === null || whitelabel === void 0 ? void 0 : whitelabel.primaryColor) || "#2055ff";
    var secondaryColor = (whitelabel === null || whitelabel === void 0 ? void 0 : whitelabel.secondaryColor) || "#000000";
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ThemeProvider/* default */.Z, {
        theme: function(theme) {
            return (0,createTheme/* default */.Z)((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, theme), {
                components: ComponentsOverrides(),
                typography: (0,_object_spread/* default */.Z)({
                    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif'
                }, theme_typography),
                palette: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, theme.palette), {
                    primary: {
                        light: muiColor/* default.light */.Z.light(primaryColor),
                        main: primaryColor,
                        dark: muiColor/* default.dark */.Z.dark(primaryColor)
                    },
                    secondary: {
                        light: muiColor/* default.light */.Z.light(secondaryColor),
                        main: secondaryColor,
                        dark: muiColor/* default.dark */.Z.dark(secondaryColor)
                    }
                })
            }));
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
            className: "no-reset",
            sx: {
                background: "#F8F8F8",
                minHeight: "100vh"
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Navbar, {
                    whitelabel: whitelabel,
                    setSection: setSection,
                    isDesktop: isDesktop,
                    hasFloorPlans: hasFloorPlans,
                    translation: tour === null || tour === void 0 ? void 0 : tour.translation
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
                    sx: {
                        py: 2
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                        spacing: 4,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Header, {
                                tour: tour,
                                isDesktop: isDesktop
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Description, {
                                text: tour.assetDescription,
                                tour: tour
                            }),
                            hasFloorPlans && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                                direction: "row",
                                spacing: 2,
                                sx: {
                                    mt: 2
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                        variant: section === "3_d_tour" ? "contained" : "outlined",
                                        size: "large",
                                        color: "primary",
                                        sx: {
                                            color: section === "3_d_tour" ? "#fff" : "gray",
                                            borderColor: "gray",
                                            "&:hover": {
                                                borderColor: "gray"
                                            }
                                        },
                                        onClick: function() {
                                            return setSection("3_d_tour");
                                        },
                                        children: (tour === null || tour === void 0 ? void 0 : (ref1 = tour.translation) === null || ref1 === void 0 ? void 0 : ref1.threeDTour) || "3D Tour"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                        variant: section === "floor_plans" ? "contained" : "outlined",
                                        color: "primary",
                                        size: "large",
                                        sx: {
                                            color: section === "floor_plans" ? "#fff" : "gray",
                                            borderColor: "gray",
                                            "&:hover": {
                                                borderColor: "gray"
                                            }
                                        },
                                        onClick: function() {
                                            return setSection("floor_plans");
                                        },
                                        children: (tour === null || tour === void 0 ? void 0 : (ref2 = tour.translation) === null || ref2 === void 0 ? void 0 : ref2.floorPlans) || "Floor Plans"
                                    })
                                ]
                            }),
                            !hasFloorPlans && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                variant: "h5",
                                sx: {
                                    marginBottom: "-15px !important"
                                },
                                children: (tour === null || tour === void 0 ? void 0 : (ref3 = tour.translation) === null || ref3 === void 0 ? void 0 : ref3.threeDTour) || "3D Tour"
                            }),
                            section === "3_d_tour" && /*#__PURE__*/ (0,jsx_runtime.jsx)(IframeResponsive, {
                                ratio: isDesktop ? "16/9" : "1/1",
                                previewSrc: "".concat("https://cdn.treedis.com", "/tours/").concat(tour.id, "/images/").concat(tour.mainImage),
                                src: "/".concat(iframeSrcPrefixByTourType, "/").concat(tour.slug, "?messenger=0"),
                                whitelabel: whitelabel
                            }),
                            section === "floor_plans" && /*#__PURE__*/ (0,jsx_runtime.jsx)(FloorPlans, {
                                tour: tour,
                                isDesktop: isDesktop
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Gallery, {
                                tour: tour
                            }),
                            (tour === null || tour === void 0 ? void 0 : tour.summary) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Summary_Summary, {
                                text: tour.summary,
                                tour: tour
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ContactAndMap, {
                                tour: tour,
                                isDesktop: isDesktop
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Footer, {
                    whitelabel: whitelabel
                })
            ]
        })
    });
}
/* harmony default export */ var modern_ModernPublicAsset = (ModernPublicAsset);

// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(11163);
var router_default = /*#__PURE__*/__webpack_require__.n(router);
;// CONCATENATED MODULE: ./components/asset/slick/SlickPublicAsset.tsx
/* eslint-disable class-methods-use-this,react/jsx-no-bind */ 























// eslint-disable-next-line @typescript-eslint/no-var-requires
var ReactTooltip = (__webpack_require__(24762)/* ["default"] */ .Z);
var SlickPublicAsset = /*#__PURE__*/ function(Component) {
    "use strict";
    (0,_inherits/* default */.Z)(SlickPublicAsset, Component);
    var _super = (0,_create_super/* default */.Z)(SlickPublicAsset);
    function SlickPublicAsset(props) {
        (0,_class_call_check/* default */.Z)(this, SlickPublicAsset);
        var _this;
        _this = _super.call(this, props);
        _this.toggleVideo = _this.toggleVideo.bind((0,_assert_this_initialized/* default */.Z)(_this));
        _this.state = {
            tour: null,
            play: false,
            videoOpen: false,
            galleryOpen: false,
            selectedPlan: null,
            schedulerDates: [],
            images: [],
            newLead: {
                firstName: null,
                lastName: null,
                email: null,
                phone: null,
                message: null
            },
            activeTab: 0,
            selectedDate: null,
            selectedAgent: 0,
            downloading: false
        };
        _this.scrollTo = _this.scrollTo.bind((0,_assert_this_initialized/* default */.Z)(_this));
        return _this;
    }
    var _proto = SlickPublicAsset.prototype;
    _proto.componentDidMount = function componentDidMount() {
        var tour = this.props.tour;
        this.setState({
            tour: tour,
            selectedPlan: tour.floorPlans.length > 0 ? tour.floorPlans[0].url : null
        });
        this.setSchedulerDates(new Date(), true);
        var menuItemClickedBookingPage = this.props.menuItemClickedBookingPage;
        if (menuItemClickedBookingPage) {
            if (menuItemClickedBookingPage === "gallery") {
                this.toggleGallery();
            } else {
                setTimeout(this.scrollTo.bind(this, menuItemClickedBookingPage), 1000);
            }
        }
    };
    _proto.setSchedulerDates = function setSchedulerDates(startDate, init) {
        var td = startDate;
        var tm = new Date(td);
        tm.setDate(tm.getDate() + 1);
        var nd = new Date(td);
        nd.setDate(nd.getDate() + 2);
        var schedulerDates = [
            td,
            tm,
            nd
        ];
        this.setState({
            schedulerDates: schedulerDates
        });
        if (init) this.setState({
            selectedDate: td
        });
    };
    _proto.editLead = function editLead(event) {
        var name = event.target.name;
        var value = event.target.type === "checkbox" ? event.target.checked : event.target.value;
        var newLead = this.state.newLead;
        newLead[name] = value;
        this.setState({
            newLead: newLead
        });
    };
    _proto.sendLead = function sendLead() {
        var _this = this;
        return (0,_async_to_generator/* default */.Z)(function() {
            var ref, ref1, params, _tour, tourEmail, client, err;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        params = Object.assign(_this.state.newLead, {
                            tour: _this.state.tour.title,
                            userId: _this.state.tour.userId,
                            link: window.location.href,
                            clientId: (ref = _this.state.tour) === null || ref === void 0 ? void 0 : (ref1 = ref.client) === null || ref1 === void 0 ? void 0 : ref1.id
                        });
                        _tour = _this.state.tour, tourEmail = _tour.tourEmail, client = _tour.client;
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            4,
                            ,
                            5
                        ]);
                        return [
                            4,
                            (0,util_all/* fetchData */.rQ)("public/sendEmail", "POST", {
                                to: tourEmail && tourEmail.assertGetInTouch || client && client.email,
                                params: params
                            })
                        ];
                    case 2:
                        _state.sent();
                        react_toastify_esm/* toast.success */.Am.success("E-Mail sent");
                        _this.setState({
                            newLead: {
                                name: null,
                                email: null,
                                phone: null,
                                message: null
                            }
                        });
                        return [
                            4,
                            (0,util_all/* fetchData */.rQ)("public/setTourLead", "POST", {
                                name: params.name,
                                email: params.email,
                                phone: params.phone,
                                category: TourLead/* LeadCategory.AssertTouchForm */.k.AssertTouchForm,
                                tourId: _this.state.tour.id
                            })
                        ];
                    case 3:
                        _state.sent();
                        return [
                            3,
                            5
                        ];
                    case 4:
                        err = _state.sent();
                        console.error(err.message);
                        return [
                            3,
                            5
                        ];
                    case 5:
                        return [
                            2
                        ];
                }
            });
        })();
    };
    _proto.switchPlan = function switchPlan(url, index) {
        var tour = this.state.tour;
        tour.floorPlans.map(function(plan) {
            plan.selected = false;
            return plan;
        });
        tour.floorPlans[index].selected = true;
        this.setState({
            tour: tour,
            selectedPlan: url
        });
    };
    _proto.downloadCurrentImage = function downloadCurrentImage(url) {
        var _this = this;
        return (0,_async_to_generator/* default */.Z)(function() {
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _this.setState({
                            loading: true
                        });
                        return [
                            4,
                            downloadImage(url, _this.state.tour)
                        ];
                    case 1:
                        _state.sent();
                        _this.setState({
                            loading: false
                        });
                        return [
                            2
                        ];
                }
            });
        })();
    };
    _proto.toggleGallery = function toggleGallery() {
        var _this = this;
        var tour = this.state.tour ? this.state.tour : this.props.tour;
        if (this.state.images.length === 0) {
            util_all/* fetchData */.rQ("public/getAllTourImages", "POST", {
                id: tour.id
            }).then(function(data) {
                if (!data.images) {
                    react_toastify_esm/* toast.error */.Am.error("Couldn't load images");
                } else {
                    var images = data.images.map(function(img) {
                        return "".concat(_this.props.reactAws, "/tours/").concat(tour.id, "/images/").concat(img.url);
                    });
                    _this.setState({
                        images: images
                    });
                }
            }).catch(function(err) {
                console.error(err.message);
            });
        }
        this.setState({
            galleryOpen: !this.state.galleryOpen,
            videoOpen: false
        });
    };
    _proto.scrollTo = function scrollTo(to) {
        this[to].scrollIntoView({
            behavior: "smooth",
            block: "end"
        });
    };
    _proto.toggleVideo = function toggleVideo() {
        var videoOpen = this.state.videoOpen;
        this.setState({
            videoOpen: !videoOpen,
            galleryOpen: false
        });
    };
    _proto.moveDates = function moveDates(older) {
        var schedulerDates = this.state.schedulerDates;
        var currentStart = schedulerDates[0];
        var newStart = new Date(currentStart);
        var diff = older ? -1 : 1;
        newStart.setDate(newStart.getDate() + diff);
        this.setSchedulerDates(newStart, false);
    };
    _proto.bookAppointment = function bookAppointment(incomingSelectedDate, appointmentType) {
        var selectedDate = encodeURIComponent(incomingSelectedDate);
        var matterId = this.props.matterId;
        router_default().push({
            pathname: "/asset/".concat(matterId, "/book"),
            query: {
                date: selectedDate,
                appointmentType: appointmentType
            }
        });
    };
    _proto.downloadAll = function downloadAll() {
        var _this = this;
        return (0,_async_to_generator/* default */.Z)(function() {
            var images;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        images = _this.state.images;
                        _this.setState({
                            downloading: true
                        });
                        return [
                            4,
                            downloadAllImages(images, _this.state.tour)
                        ];
                    case 1:
                        _state.sent();
                        _this.setState({
                            downloading: false
                        });
                        return [
                            2
                        ];
                }
            });
        })();
    };
    _proto.render = function render() {
        var _this = this;
        var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14, ref15, ref16, ref17, ref18, ref19, ref20, ref21, ref22, ref23, ref24, ref25, ref26, ref27, ref28, ref29, ref30, ref31, ref32, ref33, ref34, ref35, ref36, ref37, ref38, ref39, ref40, ref41, ref42, ref43, ref44, ref45, ref46;
        var _state = this.state, tour = _state.tour, appointmentType = _state.appointmentType, schedulerDates = _state.schedulerDates, selectedDate = _state.selectedDate, downloading = _state.downloading;
        var summaryOn = false;
        var floorPlansOn = false;
        var iframeSrcPrefixByTourType;
        var galleryImages = [];
        var fbAppId = (tour === null || tour === void 0 ? void 0 : (ref = tour.client) === null || ref === void 0 ? void 0 : ref.fbAppId) || (tour === null || tour === void 0 ? void 0 : (ref1 = tour.user) === null || ref1 === void 0 ? void 0 : ref1.fbAppId);
        var whitelabel = this.props.whitelabel;
        if (tour) {
            summaryOn = (tour.summary && tour.summary.length) > 0;
            floorPlansOn = tour.floorPlansEnabled && !!tour.floorPlans.length;
            for(var i = 0; i < 6; i += 1){
                var obj = tour.images[i] ? tour.images[i] : null;
                if (obj) galleryImages.push(obj);
            }
            iframeSrcPrefixByTourType = Tour/* TourTypeURL */.YO[tour.mode];
        }
        if (this.state.loading || !tour) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(LoadingProgress/* default */.Z, {});
        }
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            id: "public-asset-root",
            ref: function(el) {
                _this.root = el;
            },
            className: tour.client && tour.client.rtl ? "rtl slick" : "ltr slick",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)((lib_default()), {
                    className: "popup",
                    isOpen: this.state.videoOpen,
                    onRequestClose: this.toggleVideo,
                    appElement: this.root,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                            onClick: this.toggleVideo,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                className: "fa fa-times"
                            })
                        }),
                        tour.videoUrl && /*#__PURE__*/ (0,jsx_runtime.jsx)(Iframe/* default */.Z, {
                            logoSrc: whitelabel === null || whitelabel === void 0 ? void 0 : whitelabel.logo,
                            src: util_all/* getVideoLink */.rp(tour.videoUrl),
                            allowFullscreen: true
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)((lib_default()), {
                    className: "popup",
                    isOpen: this.state.galleryOpen,
                    onRequestClose: this.toggleGallery.bind(this),
                    appElement: this.root,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                            onClick: this.toggleGallery.bind(this),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                className: "fa fa-times"
                            })
                        }),
                        ((ref2 = tour.client) === null || ref2 === void 0 ? void 0 : ref2.logo) && /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            className: tour.client.widthLogo ? "logo width" : "logo",
                            src: "".concat(this.props.reactAws, "/clients/").concat(tour.client.id, "/logo.png").concat(util_all/* getVersion */.bo(tour.client.updatedAt)),
                            alt: ""
                        }),
                        ((ref3 = tour.client) === null || ref3 === void 0 ? void 0 : ref3.watermark) && /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            className: "watermark",
                            alt: "",
                            src: "".concat(this.props.reactAws, "/clients/").concat(tour.client.id, "/watermark.png").concat(util_all/* getVersion */.bo(tour.client.updatedAt))
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(react_slick_lib/* default */.Z, {
                            className: "gallery-slider",
                            infinite: false,
                            arrows: true,
                            autoplay: false,
                            dots: false,
                            fade: false,
                            children: this.state.images.map(function(image, i) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "bg",
                                        style: {
                                            backgroundImage: "url(".concat(image, ")")
                                        },
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(DownloadAll, {
                                                onClick: _this.downloadAll.bind(_this),
                                                children: downloading ? /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                    className: "fas fa-spinner fa-spin"
                                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                    className: "fas fa-angle-double-down"
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                onClick: _this.downloadCurrentImage.bind(_this, image),
                                                className: "download fas fa-cloud-download-alt"
                                            })
                                        ]
                                    })
                                }, i);
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("header", {
                    className: "slick-header w-100",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "d-flex justify-content-between align-items-center pr-5 pl-5 h-100",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "d-flex header-logo align-items-center",
                                children: ((ref4 = tour.client) === null || ref4 === void 0 ? void 0 : ref4.logo) && !tour.unbranded && /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                    className: "logo",
                                    alt: "",
                                    src: "".concat(this.props.reactAws, "/clients/").concat(tour.client.id, "/logo.png").concat(util_all/* getVersion */.bo(tour.client.updatedAt))
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "navi",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "d-flex align-items-center h-100",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                            onClick: this.scrollTo.bind(this, "overview"),
                                            children: (ref5 = tour.translation) === null || ref5 === void 0 ? void 0 : ref5.overview
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                            onClick: this.toggleGallery.bind(this),
                                            children: (ref6 = tour.translation) === null || ref6 === void 0 ? void 0 : ref6.photos
                                        }),
                                        tour.amenities && /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                            onClick: this.scrollTo.bind(this, "amenities"),
                                            children: (ref7 = tour.translation) === null || ref7 === void 0 ? void 0 : ref7.amenities
                                        }),
                                        tour.videoUrl && /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                            onClick: this.toggleVideo,
                                            children: (ref8 = tour.translation) === null || ref8 === void 0 ? void 0 : ref8.video
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                            onClick: function() {
                                                _this.scrollTo("floorPlans");
                                                _this.setState({
                                                    activeTab: 0
                                                });
                                            },
                                            children: (ref9 = tour.translation) === null || ref9 === void 0 ? void 0 : ref9.threeDTour
                                        }),
                                        floorPlansOn && /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                            onClick: function() {
                                                _this.scrollTo("floorPlans");
                                                _this.setState({
                                                    activeTab: 1
                                                });
                                            },
                                            children: (ref10 = tour.translation) === null || ref10 === void 0 ? void 0 : ref10.floorPlans
                                        }),
                                        !tour.unbranded && /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                            onClick: this.scrollTo.bind(this, "contact"),
                                            children: (ref11 = tour.translation) === null || ref11 === void 0 ? void 0 : ref11.contact
                                        }),
                                        tour.address && /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                            onClick: this.scrollTo.bind(this, "map"),
                                            children: (ref12 = tour.translation) === null || ref12 === void 0 ? void 0 : ref12.map
                                        }),
                                        tour.appointmentsOn && /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                            onClick: this.scrollTo.bind(this, "tourScheduler"),
                                            className: "schedule-btn",
                                            children: (ref13 = tour.translation) === null || ref13 === void 0 ? void 0 : ref13.scheduleTour
                                        })
                                    ]
                                })
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "content",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "intro",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "slider-overlay"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(react_slick_lib/* default */.Z, {
                                    className: "main-slider",
                                    infinite: true,
                                    arrows: false,
                                    autoplay: true,
                                    dots: false,
                                    fade: true,
                                    autoplaySpeed: 8000,
                                    speed: 3000,
                                    cssEase: "cubic-bezier(0.7, 0, 0.3, 1)",
                                    children: tour.images.slice(0, 7).map(function(image, i) {
                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "bg",
                                                style: {
                                                    backgroundImage: "url(".concat(_this.props.reactAws, "/tours/").concat(tour.id, "/images/").concat(image.url, ")")
                                                }
                                            })
                                        }, i);
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "slider-content w-100",
                            children: [
                                tour.address && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "address d-flex align-items-center mb-3",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                            className: "fas fa-map-marker-alt"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            className: "m-0 ml-3",
                                            children: tour.address
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "d-flex justify-content-between",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "w-50",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                    className: "tour-title mb-5",
                                                    children: tour.title
                                                }),
                                                tour.price && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                            className: "price-lbl mb-3",
                                                            children: "Price"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                            className: "price mb-2",
                                                            children: tour.price
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                            className: "price-old",
                                                            children: tour.oldPrice
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {}),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "d-flex align-items-end flex-column",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "option d-flex align-items-center justify-content-center",
                                                    "data-tip": (ref14 = tour.translation) === null || ref14 === void 0 ? void 0 : ref14.threeDTour,
                                                    onClick: function() {
                                                        _this.scrollTo("floorPlans");
                                                        _this.setState({
                                                            activeTab: 0
                                                        });
                                                    },
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                        className: "fas fa-hand-pointer"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ReactTooltip, {
                                                    place: "left",
                                                    effect: "solid",
                                                    type: "light"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "option d-flex align-items-center justify-content-center",
                                                    "data-tip": (ref15 = tour.translation) === null || ref15 === void 0 ? void 0 : ref15.gallery,
                                                    onClick: this.toggleGallery.bind(this),
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                        className: "fas fa-images"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ReactTooltip, {
                                                    place: "left",
                                                    effect: "solid",
                                                    type: "light"
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "info-wrapper d-flex justify-content-center w-100",
                            id: "info",
                            ref: function(el) {
                                _this.overview = el;
                            },
                            children: (tour.beds || tour.showers || tour.size || tour.cars || tour.accomodation || tour.price) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "info-box d-flex align-items-center pr-4 pl-4",
                                children: [
                                    tour.beds && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "flex-grow-1",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "d-flex",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "iconWrapper d-flex align-items-center justify-content-center",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                        className: "fas fa-bed"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "col p-0",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "d-flex justify-content-start",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            className: "col",
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                    className: "amenity",
                                                                    children: (ref16 = tour.translation) === null || ref16 === void 0 ? void 0 : ref16.rooms
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                    className: "number",
                                                                    children: tour.beds
                                                                })
                                                            ]
                                                        })
                                                    })
                                                })
                                            ]
                                        })
                                    }),
                                    tour.showers && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "flex-grow-1",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "d-flex",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "iconWrapper d-flex align-items-center justify-content-center",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                        className: "fas fa-shower"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "col p-0",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "d-flex justify-content-start",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            className: "col",
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                    className: "amenity",
                                                                    children: (ref17 = tour.translation) === null || ref17 === void 0 ? void 0 : ref17.bathrooms
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                    className: "number",
                                                                    children: tour.showers
                                                                })
                                                            ]
                                                        })
                                                    })
                                                })
                                            ]
                                        })
                                    }),
                                    tour.cars && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "flex-grow-1",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "d-flex",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "iconWrapper d-flex align-items-center justify-content-center",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                        className: "fas fa-car"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "col p-0",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "d-flex justify-content-start",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            className: "col",
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                    className: "amenity",
                                                                    children: (ref18 = tour.translation) === null || ref18 === void 0 ? void 0 : ref18.parkingSpots
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                    className: "number",
                                                                    children: tour.cars
                                                                })
                                                            ]
                                                        })
                                                    })
                                                })
                                            ]
                                        })
                                    }),
                                    tour.accomodation && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "flex-grow-1",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "d-flex",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "iconWrapper d-flex align-items-center justify-content-center",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                        className: "fas fa-home"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "col p-0",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "d-flex justify-content-start",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            className: "col",
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                    className: "amenity",
                                                                    children: (ref19 = tour.translation) === null || ref19 === void 0 ? void 0 : ref19.accommodation
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                    className: "number",
                                                                    children: tour.accomodation
                                                                })
                                                            ]
                                                        })
                                                    })
                                                })
                                            ]
                                        })
                                    }),
                                    tour.size && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "flex-grow-1",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "d-flex",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "iconWrapper d-flex align-items-center justify-content-center",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                        className: "fas fa-ruler-combined"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "col p-0",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "d-flex justify-content-start",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            className: "col",
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                    className: "amenity",
                                                                    children: (ref20 = tour.translation) === null || ref20 === void 0 ? void 0 : ref20.size
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                                    className: "number",
                                                                    children: [
                                                                        tour.size,
                                                                        " ",
                                                                        tour.unitSystem === "metric" ? "m2" : "ft"
                                                                    ]
                                                                })
                                                            ]
                                                        })
                                                    })
                                                })
                                            ]
                                        })
                                    }),
                                    tour.price && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "flex-grow-1",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "d-flex",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "iconWrapper d-flex align-items-center justify-content-center",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                        className: "fas fa-money-bill-wave"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "col p-0",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "d-flex justify-content-start",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            className: "col",
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                    className: "amenity",
                                                                    children: (ref21 = tour.translation) === null || ref21 === void 0 ? void 0 : ref21.price
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                    className: "number",
                                                                    children: tour.price
                                                                })
                                                            ]
                                                        })
                                                    })
                                                })
                                            ]
                                        })
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "details",
                            children: [
                                summaryOn && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "d-flex justify-content-center",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "w-50 m-0 summary",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(summary_Summary, {
                                            tour: tour
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    id: "gallery",
                                    className: "d-flex justify-content-center flex-column align-items-center",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "row w-75 justify-content-center",
                                            children: galleryImages.map(function(image, i) {
                                                return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: i > 2 ? "align-start gcol gcol-".concat(i) : "gcol gcol-".concat(i),
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "img",
                                                        onClick: _this.toggleGallery.bind(_this),
                                                        style: image.url ? {
                                                            backgroundImage: "url(".concat(_this.props.reactAws, "/tours/").concat(tour.id, "/images/").concat(image.url, ")")
                                                        } : {}
                                                    })
                                                }, i);
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                            onClick: this.toggleGallery.bind(this),
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "secondary-btn mt-5 mb-5",
                                                children: (ref22 = tour.translation) === null || ref22 === void 0 ? void 0 : ref22.gallery
                                            })
                                        })
                                    ]
                                }),
                                tour.appointmentsOn && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    id: "tourScheduler",
                                    className: "slick-section grey-section",
                                    ref: function(el) {
                                        _this.tourScheduler = el;
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "d-flex justify-content-center",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "w-50",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                                    className: "title",
                                                    children: (ref23 = tour.translation) === null || ref23 === void 0 ? void 0 : ref23.tourHouse
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "d-flex",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            className: "col-8",
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                    className: "d-flex",
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                            className: "d-flex flex-column justify-content-center",
                                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                                className: "chevron-wrapper",
                                                                                onClick: this.moveDates.bind(this, true),
                                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                                                    className: "download fas fa-chevron-left"
                                                                                })
                                                                            })
                                                                        }),
                                                                        schedulerDates && selectedDate && schedulerDates.map(function(date, i) {
                                                                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                                className: "col",
                                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                                    className: selectedDate === date ? "selected" : "",
                                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                                        className: "date d-flex flex-column justify-content-center",
                                                                                        onClick: function() {
                                                                                            _this.setState({
                                                                                                selectedDate: date
                                                                                            });
                                                                                        },
                                                                                        children: [
                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h6", {
                                                                                                children: date.toLocaleString("en-US", {
                                                                                                    weekday: "long"
                                                                                                })
                                                                                            }),
                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h6", {
                                                                                                className: "day mt-2 mb-2",
                                                                                                children: date.getDate().toString()
                                                                                            }),
                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h6", {
                                                                                                children: date.toLocaleString("default", {
                                                                                                    month: "short"
                                                                                                })
                                                                                            })
                                                                                        ]
                                                                                    })
                                                                                })
                                                                            }, i);
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                            className: "d-flex flex-column justify-content-center",
                                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                                className: "chevron-wrapper",
                                                                                onClick: this.moveDates.bind(this, false),
                                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                                                    className: "download fas fa-chevron-right"
                                                                                })
                                                                            })
                                                                        })
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                    className: "d-flex justify-content-end",
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                        className: "info",
                                                                        children: "it's free, with no obligation - cancel anytime"
                                                                    })
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            className: "col-4 buttons",
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                    className: appointmentType === "person" ? "btn selected d-flex" : "btn d-flex",
                                                                    onClick: function() {
                                                                        _this.setState({
                                                                            appointmentType: "person"
                                                                        });
                                                                    },
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                                            className: "download fas fa-home mr-2"
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                            children: "Tour in Person"
                                                                        })
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                    role: "button",
                                                                    className: appointmentType === "video" ? "btn selected d-flex" : "btn d-flex",
                                                                    onClick: function() {
                                                                        _this.setState({
                                                                            appointmentType: "video"
                                                                        });
                                                                    },
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                                            className: "download fas fa-video mr-2"
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                            children: "Tour via Video Chat"
                                                                        })
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                    className: "btn secondary d-flex",
                                                                    onClick: this.bookAppointment.bind(this, selectedDate, appointmentType),
                                                                    children: "Schedule Tour"
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    })
                                }),
                                tour.videoUrl && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "slick-section",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "d-flex justify-content-center",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "w-50",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                                    className: "title",
                                                    children: (ref24 = tour.translation) === null || ref24 === void 0 ? void 0 : ref24.video
                                                }),
                                                tour.videoUrl && /*#__PURE__*/ (0,jsx_runtime.jsx)(Iframe/* default */.Z, {
                                                    logoSrc: whitelabel === null || whitelabel === void 0 ? void 0 : whitelabel.logo,
                                                    className: "video",
                                                    src: util_all/* getVideoLink */.rp(tour.videoUrl, {
                                                        autoplay: 0
                                                    }),
                                                    allowFullscreen: true
                                                })
                                            ]
                                        })
                                    })
                                }),
                                tour.amenities && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "slick-section",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "d-flex justify-content-center",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "w-50",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                                    className: "title",
                                                    children: (ref25 = tour.translation) === null || ref25 === void 0 ? void 0 : ref25.amenities
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "amenity-img",
                                                    style: {
                                                        backgroundImage: "url(".concat(this.props.reactAws, "/tours/").concat(tour.id, "/images/").concat(tour.mainImage, ")")
                                                    }
                                                })
                                            ]
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "slick-section",
                                    id: "tour-floorPlan",
                                    ref: function(el) {
                                        _this.floorPlans = el;
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "d-flex justify-content-center",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "w-50",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "d-flex justify-content-start",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                                            className: this.state.activeTab === 0 ? "title active" : "title",
                                                            onClick: function() {
                                                                _this.setState({
                                                                    activeTab: 0
                                                                });
                                                            },
                                                            children: (ref26 = tour.translation) === null || ref26 === void 0 ? void 0 : ref26.threeDTour
                                                        }),
                                                        floorPlansOn && /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                                            className: this.state.activeTab === 1 ? "title ml-3 active" : "title ml-3",
                                                            onClick: function() {
                                                                _this.setState({
                                                                    activeTab: 1
                                                                });
                                                            },
                                                            children: (ref27 = tour.translation) === null || ref27 === void 0 ? void 0 : ref27.floorPlans
                                                        })
                                                    ]
                                                }),
                                                this.state.activeTab === 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "inner-tab tab-1",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: "section tour",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                className: "inner",
                                                                children: [
                                                                    !this.state.play && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                        className: "overlay",
                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                            className: "text",
                                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                                                alt: "",
                                                                                src: "/images/play.svg",
                                                                                onClick: function() {
                                                                                    _this.setState({
                                                                                        play: true
                                                                                    });
                                                                                }
                                                                            })
                                                                        })
                                                                    }),
                                                                    !this.state.play && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                        className: "bg",
                                                                        style: {
                                                                            backgroundImage: "url(".concat(this.props.reactAws, "/tours/").concat(tour.id, "/images/").concat(tour.mainImage, ")")
                                                                        }
                                                                    }),
                                                                    this.state.play && /*#__PURE__*/ (0,jsx_runtime.jsx)(Iframe/* default */.Z, {
                                                                        logoSrc: whitelabel === null || whitelabel === void 0 ? void 0 : whitelabel.logo,
                                                                        src: "/".concat(iframeSrcPrefixByTourType, "/").concat(tour.slug, "?messenger=0"),
                                                                        allowFullscreen: true
                                                                    })
                                                                ]
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: "clearfix"
                                                        })
                                                    ]
                                                }),
                                                this.state.activeTab === 1 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "inner-tab tab-1",
                                                    children: [
                                                        floorPlansOn && /*#__PURE__*/ (0,jsx_runtime.jsx)(FloorPlan, {
                                                            tour: tour,
                                                            selectedPlan: this.state.selectedPlan,
                                                            switchPlan: this.switchPlan.bind(this),
                                                            imgLong: true,
                                                            className: "h-100"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: "clearfix"
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    id: "contact",
                                    className: "slick-section",
                                    ref: function(el) {
                                        _this.contact = el;
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "d-flex justify-content-center",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "w-50",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                                    className: "title",
                                                    children: (ref28 = tour.translation) === null || ref28 === void 0 ? void 0 : ref28.contact
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "d-flex",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            className: "col-4 p-0 agents",
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                    className: "tab-title mb-5",
                                                                    children: "Presented by"
                                                                }),
                                                                tour.agents.length === 0 && tour.client && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                    className: "selected",
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                        className: "d-flex align-items-center agent-wrapper",
                                                                        children: [
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                                className: "agent-profile mr-3",
                                                                                style: {
                                                                                    backgroundImage: "url(".concat(this.props.reactAws, "/clients/").concat(tour.client.id, "/logo.png").concat(util_all/* getVersion */.bo(tour.client.updatedAt), ")")
                                                                                }
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                                className: "agent-info d-flex flex-column align-items-start",
                                                                                children: [
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                                        className: "name",
                                                                                        children: tour.client.name
                                                                                    }),
                                                                                    ((ref29 = tour.client) === null || ref29 === void 0 ? void 0 : ref29.website) && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                                            href: ((ref30 = tour.client) === null || ref30 === void 0 ? void 0 : (ref31 = ref30.website) === null || ref31 === void 0 ? void 0 : ref31.includes("https://")) ? tour.client.website : "https://".concat((ref32 = tour.client) === null || ref32 === void 0 ? void 0 : ref32.website),
                                                                                            rel: "noreferrer",
                                                                                            target: "_blank",
                                                                                            children: "WEBSITE"
                                                                                        })
                                                                                    }),
                                                                                    tour.client.phone && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                                        children: tour.client.phone
                                                                                    }),
                                                                                    tour.client.email && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                                        children: tour.client.email
                                                                                    })
                                                                                ]
                                                                            })
                                                                        ]
                                                                    })
                                                                }),
                                                                tour.agents.map(function(agent, i) {
                                                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                        className: _this.state.selectedAgent === i ? "selected" : "",
                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                            className: "d-flex align-items-center agent-wrapper",
                                                                            onClick: function() {
                                                                                _this.setState({
                                                                                    selectedAgent: i
                                                                                });
                                                                            },
                                                                            children: [
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                                    className: "agent-profile mr-3",
                                                                                    style: {
                                                                                        backgroundImage: "url(".concat(agent.logo, ")")
                                                                                    }
                                                                                }),
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                                    className: "agent-info d-flex flex-column align-items-start",
                                                                                    children: [
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                                            className: "name",
                                                                                            children: agent.name
                                                                                        }),
                                                                                        agent.phone && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                                            children: agent.phone
                                                                                        }),
                                                                                        agent.email && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                                            children: agent.email
                                                                                        })
                                                                                    ]
                                                                                })
                                                                            ]
                                                                        })
                                                                    }, i);
                                                                })
                                                            ]
                                                        }),
                                                        tour.contactForm && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            className: "col-8 p-0 ml-5 contact-form",
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                    className: "tab-title mb-5",
                                                                    children: (ref33 = tour.translation) === null || ref33 === void 0 ? void 0 : ref33.getInTouch
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                            className: "d-flex justify-content-between",
                                                                            children: [
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                                                    type: "text",
                                                                                    className: "name",
                                                                                    placeholder: (ref34 = tour.translation) === null || ref34 === void 0 ? void 0 : ref34.name,
                                                                                    name: "firstName",
                                                                                    value: this.state.newLead.firstName ? this.state.newLead.firstName : "",
                                                                                    onChange: this.editLead.bind(this)
                                                                                }),
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {}),
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                                                    type: "text",
                                                                                    className: "name",
                                                                                    placeholder: (ref35 = tour.translation) === null || ref35 === void 0 ? void 0 : ref35.name,
                                                                                    name: "lastName",
                                                                                    value: this.state.newLead.lastName ? this.state.newLead.lastName : "",
                                                                                    onChange: this.editLead.bind(this)
                                                                                })
                                                                            ]
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                                            type: "text",
                                                                            placeholder: (ref36 = tour.translation) === null || ref36 === void 0 ? void 0 : ref36.email,
                                                                            name: "email",
                                                                            value: this.state.newLead.email ? this.state.newLead.email : "",
                                                                            onChange: this.editLead.bind(this)
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                                            type: "text",
                                                                            placeholder: (ref37 = tour.translation) === null || ref37 === void 0 ? void 0 : ref37.phone,
                                                                            name: "phone",
                                                                            value: this.state.newLead.phone ? this.state.newLead.phone : "",
                                                                            onChange: this.editLead.bind(this)
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                                            type: "text",
                                                                            placeholder: (ref38 = tour.translation) === null || ref38 === void 0 ? void 0 : ref38.message,
                                                                            name: "message",
                                                                            value: this.state.newLead.message ? this.state.newLead.message : "",
                                                                            onChange: this.editLead.bind(this)
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                            className: "secondary-btn submit mt-4",
                                                                            onClick: this.sendLead.bind(this),
                                                                            children: (ref39 = tour.translation) === null || ref39 === void 0 ? void 0 : ref39.submit
                                                                        })
                                                                    ]
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    })
                                })
                            ]
                        }),
                        tour.address && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "overview h-400",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "container m-0 w-100 h-100",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "row h-100",
                                    ref: function(el) {
                                        _this.map = el;
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(map_Map, {
                                        logo: whitelabel === null || whitelabel === void 0 ? void 0 : whitelabel.logo,
                                        address: tour.address,
                                        googleKey: this.props.googleKey
                                    })
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("footer", {
                            className: "d-flex justify-content-center",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "w-50 d-flex justify-content-between",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        href: whitelabel === null || whitelabel === void 0 ? void 0 : whitelabel.website,
                                        rel: "noreferrer",
                                        target: "_blank",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                            className: "slick-logo",
                                            src: whitelabel === null || whitelabel === void 0 ? void 0 : whitelabel.logo,
                                            alt: ""
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {}),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                rel: "noreferrer",
                                                target: "_blank",
                                                href: "https://www.facebook.com/dialog/share?app_id=".concat(fbAppId || "741048509750318", "&display=popup&href=").concat(encodeURIComponent(window.location.href), "&redirect_uri=").concat(encodeURIComponent(window.location.href)),
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                    className: "fab fa-facebook"
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                rel: "noreferrer",
                                                target: "_blank",
                                                href: "https://twitter.com/intent/tweet?text=".concat(encodeURIComponent(window.location.href)),
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                    className: "fab fa-twitter"
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                rel: "noreferrer",
                                                target: "_blank",
                                                href: "https://wa.me/?text=".concat(encodeURIComponent(window.location.href)),
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                    className: "fab fa-whatsapp"
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                rel: "noreferrer",
                                                target: "_blank",
                                                href: "mailto:?body=".concat(encodeURIComponent(window.location.href)),
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                    className: "fas fa-envelope"
                                                })
                                            })
                                        ]
                                    })
                                ]
                            })
                        })
                    ]
                }),
                tour && !tour.hideCookie && /*#__PURE__*/ (0,jsx_runtime.jsx)(CookieConsent/* CustomCookieConsent */.Le, {
                    tour: tour,
                    loaded: false,
                    message: (ref40 = tour.translation) === null || ref40 === void 0 ? void 0 : ref40.cookieConsentText,
                    accept: (ref41 = tour.translation) === null || ref41 === void 0 ? void 0 : ref41.cookieConsentAccept,
                    decline: (ref42 = tour.translation) === null || ref42 === void 0 ? void 0 : ref42.cookieConsentDecline,
                    messageMandatoryTitle: (ref43 = tour.translation) === null || ref43 === void 0 ? void 0 : ref43.cookieConsentTextMandatoryTitle,
                    messageMandatoryDescription: (ref44 = tour.translation) === null || ref44 === void 0 ? void 0 : ref44.cookieConsentTextMandatoryDescription,
                    acceptMandatory: (ref45 = tour.translation) === null || ref45 === void 0 ? void 0 : ref45.cookieConsentAcceptMandatory,
                    declineMandatory: (ref46 = tour.translation) === null || ref46 === void 0 ? void 0 : ref46.cookieConsentDeclineMandatory
                })
            ]
        });
    };
    return SlickPublicAsset;
}(react.Component);


// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
;// CONCATENATED MODULE: ./components/Asset.tsx
















// eslint-disable-next-line @typescript-eslint/no-var-requires
var MessengerCustomerChat = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 9538).then(__webpack_require__.bind(__webpack_require__, 89538));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(89538)
            ];
        }
    },
    ssr: false
});
var PublicAsset = /*#__PURE__*/ function(Component) {
    "use strict";
    (0,_inherits/* default */.Z)(PublicAsset, Component);
    var _super = (0,_create_super/* default */.Z)(PublicAsset);
    function PublicAsset(props) {
        (0,_class_call_check/* default */.Z)(this, PublicAsset);
        var _this;
        _this = _super.call(this, props);
        _this.state = {
            tour: null,
            whiteLabelData: null
        };
        _this.setWhiteLabel = util_all/* setWhiteLabel.bind */.Jw.bind((0,_assert_this_initialized/* default */.Z)(_this));
        return _this;
    }
    var _proto = PublicAsset.prototype;
    _proto.componentDidMount = function componentDidMount() {
        var _this = this;
        util_all/* fetchData */.rQ("public/getAsset", "POST", {
            id: this.props.matterId
        }).then(function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function(data) {
                var tour;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    if (!data.tour) {
                        react_toastify_esm/* toast.error */.Am.error("Couldn't find this tour in our databases");
                    } else {
                        // @ts-ignore
                        window.tourId = data.tour.id;
                        // @ts-ignore
                        window.multiPath = [];
                        tour = new Tour/* Tour */.Oj(data.tour);
                        if (tour.floorPlans.length > 0) tour.floorPlans[0].selected = true;
                        _this.setWhiteLabel(tour);
                        _this.setState({
                            tour: tour,
                            selectedPlan: tour.floorPlans.length > 0 ? tour.floorPlans[0].url : null
                        });
                    }
                    return [
                        2
                    ];
                });
            });
            return function(data) {
                return _ref.apply(this, arguments);
            };
        }()).catch(function(err) {
            console.error(err.message);
        });
    };
    _proto.render = function render() {
        var _state = this.state, tour = _state.tour, whiteLabelData = _state.whiteLabelData;
        return tour ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            children: [
                tour.assetPageType === Tour/* AssetPageType.Classic */.lC.Classic && /*#__PURE__*/ (0,jsx_runtime.jsx)(ClassicPublicAsset, {
                    tour: tour,
                    whitelabel: whiteLabelData,
                    selectedPlan: this.state.selectedPlan,
                    googleKey: this.props.googleKey,
                    reactAws: this.props.reactAws,
                    menuItemClickedBookingPage: this.props.menuItemClickedBookingPage
                }),
                tour.assetPageType === Tour/* AssetPageType.Slick */.lC.Slick && /*#__PURE__*/ (0,jsx_runtime.jsx)(SlickPublicAsset, {
                    tour: tour,
                    whitelabel: whiteLabelData,
                    selectedPlan: this.state.selectedPlan,
                    googleKey: this.props.googleKey,
                    reactAws: this.props.reactAws,
                    menuItemClickedBookingPage: this.props.menuItemClickedBookingPage,
                    matterId: this.props.matterId
                }),
                tour.assetPageType === Tour/* AssetPageType.Modern */.lC.Modern && /*#__PURE__*/ (0,jsx_runtime.jsx)(modern_ModernPublicAsset, {
                    tour: tour,
                    whitelabel: whiteLabelData,
                    selectedPlan: this.state.selectedPlan,
                    googleKey: this.props.googleKey,
                    reactAws: this.props.reactAws,
                    menuItemClickedBookingPage: this.props.menuItemClickedBookingPage,
                    matterId: this.props.matterId
                }),
                tour.messengerLink && tour.messengerGreeting && /*#__PURE__*/ (0,jsx_runtime.jsx)(MessengerCustomerChat, {
                    pageId: tour.messengerLink,
                    loggedInGreeting: tour.messengerGreeting,
                    loggedOutGreeting: tour.messengerGreeting,
                    themeColor: (whiteLabelData === null || whiteLabelData === void 0 ? void 0 : whiteLabelData.secondaryColor) || "#ea475c"
                })
            ]
        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(LoadingProgress/* default */.Z, {});
    };
    return PublicAsset;
}(react.Component);



/***/ }),

/***/ 12978:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ units_Iframe; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-player/lib/index.js
var lib = __webpack_require__(22004);
;// CONCATENATED MODULE: ./units/Iframe/IframeStyledHOC.tsx




var IframeStyledHOC = function(_param) {
    var onLoad = _param.onLoad, rest = (0,_object_without_properties/* default */.Z)(_param, [
        "onLoad"
    ]);
    var playerRef = (0,react.useRef)();
    var getPlayerInstanceAndTryToPlay = function() {
        try {
            if (rest.autoplay) {
                var ref;
                // youtube autoplay fix
                var ytPlayer = (ref = playerRef.current) === null || ref === void 0 ? void 0 : ref.getInternalPlayer();
                if (typeof (ytPlayer === null || ytPlayer === void 0 ? void 0 : ytPlayer.playVideo) === "function") {
                    ytPlayer === null || ytPlayer === void 0 ? void 0 : ytPlayer.playVideo();
                }
            }
            onLoad();
        } catch (err) {
            console.error(err);
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(lib/* default */.Z, {
        width: "100%",
        height: "100%",
        controls: true,
        url: rest.url,
        onReady: getPlayerInstanceAndTryToPlay,
        playing: rest.autoplay,
        muted: rest.mute,
        ref: playerRef
    });
};
/* harmony default export */ var Iframe_IframeStyledHOC = (/*#__PURE__*/(0,react.memo)(IframeStyledHOC));

// EXTERNAL MODULE: ./units/Iframe/style.tsx
var style = __webpack_require__(54811);
;// CONCATENATED MODULE: ./units/Iframe/index.tsx





var Iframe = function(_param) {
    var src = _param.src, logoSrc = _param.logoSrc, useModernPlayer = _param.useModernPlayer, rest = (0,_object_without_properties/* default */.Z)(_param, [
        "src",
        "logoSrc",
        "useModernPlayer"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(style/* Root */.fC, {
        children: useModernPlayer ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Iframe_IframeStyledHOC, (0,_object_spread/* default */.Z)({
            width: "100%",
            height: "100%",
            src: src,
            onLoad: function() {}
        }, rest)) : /*#__PURE__*/ (0,jsx_runtime.jsx)(style/* IframeStyled */.C, (0,_object_spread/* default */.Z)({
            width: "100%",
            height: "100%",
            src: src,
            allow: "accelerometer; encrypted-media; gyroscope; picture-in-picture; autoplay; fullscreen; camera; microphone; clipboard-read; clipboard-write; display-capture; geolocation; xr-spatial-tracking",
            onLoad: function() {}
        }, rest))
    });
};
/* harmony default export */ var units_Iframe = (Iframe);


/***/ }),

/***/ 54811:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "C": function() { return /* binding */ IframeStyled; },
/* harmony export */   "aN": function() { return /* binding */ Loader; },
/* harmony export */   "fC": function() { return /* binding */ Root; }
/* harmony export */ });
/* unused harmony exports Logo, Spinner */
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(18533);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  from {\n    transform: rotate(0deg);\n  }\n\n  to {\n    transform: rotate(360deg);\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: 100% !important;\n  height: 100% !important;\n  position: relative;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  position: absolute;\n  top: 0;\n  right: 0;\n  left: 0;\n  bottom: 0;\n  pointer-events: none;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: 115px;\n  height: 115px;\n  object-fit: contain;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  position: absolute;\n\n  & img {\n    object-fit: contain;\n    height: 100%;\n    width: 100%;\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  min-width: 150px;\n  min-height: 150px;\n  width: 150px;\n  height: 150px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  position: absolute;\n\n  &::after {\n    content: ' ';\n    display: block;\n    width: 100%;\n    height: 100%;\n    margin: 0;\n    position: absolute;\n    border-radius: 50%;\n    border: 3px solid #fff;\n    border-color: var(--color-secondary) transparent var(--color-secondary) transparent;\n    animation: ",
        " 1.2s linear infinite;\n    top: 0;\n    left: 0;\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  html body img {\n    height: 100%;\n    width: 100%;\n  }\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}

var spinner = (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* .keyframes */ .F4)(_templateObject());
var Root = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    displayName: "style__Root",
    componentId: "sc-5c3f9880-0"
})(_templateObject1());
var Loader = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    displayName: "style__Loader",
    componentId: "sc-5c3f9880-1"
})(_templateObject2());
var Logo = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    displayName: "style__Logo",
    componentId: "sc-5c3f9880-2"
})(_templateObject3());
var Spinner = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    displayName: "style__Spinner",
    componentId: "sc-5c3f9880-3"
})(_templateObject4(), spinner);
var IframeStyled = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].iframe.withConfig */ .ZP.iframe.withConfig({
    displayName: "style__IframeStyled",
    componentId: "sc-5c3f9880-4"
})(_templateObject5());


/***/ }),

/***/ 19245:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ getRatio; }
/* harmony export */ });
function getRatio() {
    var ratio = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "1/1";
    return ({
        "4/3": "calc(100% / 4 * 3)",
        "3/4": "calc(100% / 3 * 4)",
        "6/4": "calc(100% / 6 * 4)",
        "4/6": "calc(100% / 4 * 6)",
        "16/9": "calc(100% / 16 * 9)",
        "9/16": "calc(100% / 9 * 16)",
        "21/9": "calc(100% / 21 * 9)",
        "9/21": "calc(100% / 9 * 21)",
        "1/1": "100%"
    })[ratio];
}


/***/ })

}]);